/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 199);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(137), __esModule: true };

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(53)('wks')
  , uid        = __webpack_require__(35)
  , Symbol     = __webpack_require__(3).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(8)
  , IE8_DOM_DEFINE = __webpack_require__(151)
  , toPrimitive    = __webpack_require__(166)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(5) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(4)
  , createDesc = __webpack_require__(30);
module.exports = __webpack_require__(5) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(3)
  , core      = __webpack_require__(0)
  , ctx       = __webpack_require__(12)
  , hide      = __webpack_require__(6)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(139);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(17);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(138), __esModule: true };

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(33)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(164)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(27)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(128);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(24)
  , TAG = __webpack_require__(2)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(12)
  , call        = __webpack_require__(48)
  , isArrayIter = __webpack_require__(47)
  , anObject    = __webpack_require__(8)
  , toLength    = __webpack_require__(18)
  , getIterFn   = __webpack_require__(36)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(24);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(155)
  , $export        = __webpack_require__(9)
  , redefine       = __webpack_require__(162)
  , hide           = __webpack_require__(6)
  , has            = __webpack_require__(13)
  , Iterators      = __webpack_require__(11)
  , $iterCreate    = __webpack_require__(153)
  , setToStringTag = __webpack_require__(31)
  , getPrototypeOf = __webpack_require__(159)
  , ITERATOR       = __webpack_require__(2)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(35)('meta')
  , isObject = __webpack_require__(7)
  , has      = __webpack_require__(13)
  , setDesc  = __webpack_require__(4).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(10)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(160)
  , enumBugKeys = __webpack_require__(46);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(4).f
  , has = __webpack_require__(13)
  , TAG = __webpack_require__(2)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(53)('keys')
  , uid    = __webpack_require__(35);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(26)
  , defined = __webpack_require__(17);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(23)
  , ITERATOR  = __webpack_require__(2)('iterator')
  , Iterators = __webpack_require__(11);
module.exports = __webpack_require__(0).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(170);
var global        = __webpack_require__(3)
  , hide          = __webpack_require__(6)
  , Iterators     = __webpack_require__(11)
  , TO_STRING_TAG = __webpack_require__(2)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(56)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(190)
  , createDesc = __webpack_require__(191);
module.exports = __webpack_require__(39) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__device_factory_js__ = __webpack_require__(99);
/* @ngInject */


// kv.device
// -------------
//
// Which device is the user using? What version? User Agent stuff ...
//
// - [KvDevice](#kvdevice)
var DeviceModule = angular.module('kv.device', []).factory('KvDevice', __WEBPACK_IMPORTED_MODULE_0__device_factory_js__["a" /* KvDeviceFactory */]).name;

/* harmony default export */ __webpack_exports__["a"] = DeviceModule;

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__querystring_factory_js__ = __webpack_require__(112);


// kv.querystring
// -------------
//
// Helper module to parse and stringify querystrings
//
// - [KvQueryString](#kvquerystring)

var QueryStringModule = angular.module('kv.querystring', []).factory('KvQueryString', __WEBPACK_IMPORTED_MODULE_0__querystring_factory_js__["a" /* KvQueryString */]).name;

/* harmony default export */ __webpack_exports__["a"] = QueryStringModule;

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DefaultError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorLevels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCoreError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getInputError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HttpErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BankIdErrors; });


// Our error taxonomy inspired by microsoft gucodeelines:
// https://github.com/Microsoft/api-guidelines/blob/master/Guidelines.md#51-errors
// and an attempt to order by increasing severity score
var ErrorLevels = {
  FAULT_UNKNOWN: 0, // not sure where to place this?
  ERROR_USER_INPUT: 1,
  ERROR_USER: 2,
  ERROR: 3,
  FAULT_THIRD_PARTY: 4,
  FAULT_CORE: 5
};

// Http layer errors
var HttpErrors = {
  '-1': {
    code: 'NETWORK_ERROR',
    message: 'Something went wrong below the HTTP network layer',
    severity: ErrorLevels.FAULT_UNKNOWN
  },
  500: {
    code: 'HTTP_SERVER_ERROR',
    severity: ErrorLevels.FAULT_CORE
  },
  502: {
    code: 'HTTP_SERVER_BAD_GATEWAY',
    severity: ErrorLevels.FAULT_CORE
  },
  503: {
    code: 'HTTP_SERVER_UNAVAILABLE',
    severity: ErrorLevels.FAULT_CORE
  },
  400: {
    code: 'HTTP_BAD_REQUEST',
    severity: ErrorLevels.ERROR
  },
  401: {
    code: 'HTTP_UNAUTHORIZED',
    severity: ErrorLevels.ERROR
  },
  404: {
    code: 'HTTP_NOT_FOUND',
    severity: ErrorLevels.ERROR
  },
  405: {
    code: 'HTTP_NOT_ALLOWED',
    severity: ErrorLevels.ERROR
  },
  408: {
    code: 'HTTP_CLIENT_TIMEOUT',
    severity: ErrorLevels.ERROR
  }
};

// BankID layer error
var BankIdErrors = {
  'already_in_progress': {
    code: 'BANKID_ALREADY_IN_PROGRESS',
    message: 'Already in progress, cancelled',
    severity: ErrorLevels.ERROR_USER
  },
  'internal_error': {
    code: 'BANKID_INTERNAL_ERROR',
    message: 'Internal error, retry',
    severity: ErrorLevels.FAULT_THIRD_PARTY
  },
  'user_cancel': {
    code: 'BANKID_USER_CANCEL',
    message: 'Action cancelled',
    severity: ErrorLevels.ERROR_USER
  },
  'expired_transaction': {
    code: 'BANKID_EXPIRED_TRANSACTION',
    message: 'The BankID app is not responding. Please check that the program is started and that you have internet access. If you don’t have a valcode BankID you can get one from your bank. Try again.',
    severity: ErrorLevels.ERROR_USER
  },
  'client_err': {
    code: 'BANKID_CLIENT_ERR',
    message: 'Internal error. Update your BankID app and try again.',
    severity: ErrorLevels.ERROR
  },
  'certificate_err': {
    code: 'BANKID_CERTIFICATE_ERR',
    message: 'The BankID you are trying to use is revoked or too old. Please use another BankID or order a new one from your internet bank.',
    severity: ErrorLevels.ERROR
  },
  'start_failed': {
    code: 'BANKID_START_FAILED',
    message: 'The BankID app couldn’t be found on your computer or mobile device. Please install it and order a BankID from your internet bank. Install the app from install.bankcode.com.',
    severity: ErrorLevels.ERROR_USER
  }
};

// Form input layer error
var getInputError = function getInputError(data) {
  return {
    code: 'BAD_ARGUMENT',
    severity: ErrorLevels.ERROR_USER_INPUT,
    message: 'Some of the keys had invalid values',
    // Backend currently only respond with error code for one key
    details: [{
      code: 'CORE_API_BAD_ARGUMENT_' + data.code,
      description: data.long_message,
      target: data.keys[0]
    }]
  };
};

// Actually nice errors from core
var getCoreError = function getCoreError(data, status) {
  return {
    code: 'CORE_' + data.code,
    severity: status < 500 ? ErrorLevels.ERROR_USER_INPUT : ErrorLevels.FAULT_CORE,
    message: data.long_message
  };
};

// If we cant treat it as any more specific error
var DefaultError = {
  code: 'ERROR_UNKNOWN',
  message: 'unknown error',
  severity: ErrorLevels.FAULT_UNKNOWN
};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7)
  , document = __webpack_require__(3).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(11)
  , ITERATOR   = __webpack_require__(2)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(8);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(8)
  , dPs         = __webpack_require__(157)
  , enumBugKeys = __webpack_require__(46)
  , IE_PROTO    = __webpack_require__(32)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(45)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(150).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(9)
  , core    = __webpack_require__(0)
  , fails   = __webpack_require__(10);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(6);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(177);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 57 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(193)('wks')
  , uid        = __webpack_require__(57)
  , Symbol     = __webpack_require__(15).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alert_controller_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_factory_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alert_dict_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alert_directive_js__ = __webpack_require__(75);





// kv.alerts
// -------------
//
// Module for event driven alert management and presentation
// Includes an alert-factory that lets a controller emit alert objects on the controllers scope
// Presentation of these objects is then handled by the alert-directive that should be embededd
// in the controller's view's view template
//
// - [AlertsCtrl](#alertsdict)
// - [AlertsDict](#alertsdict)
// - [KvAlert](#kvalert)
// - [AlertsFactory](#alertsfactory)

var AlertModule = angular.module('kv.alerts', []).constant('AlertsDict', new __WEBPACK_IMPORTED_MODULE_2__alert_dict_js__["a" /* GetAlertsDict */]()).controller('AlertsCtrl', __WEBPACK_IMPORTED_MODULE_0__alert_controller_js__["a" /* AlertsCtrl */]).directive('kvAlert', __WEBPACK_IMPORTED_MODULE_3__alert_directive_js__["a" /* kvAlert */]).factory('AlertsFactory', __WEBPACK_IMPORTED_MODULE_1__alert_factory_js__["a" /* AlertsFactory */]);

/* unused harmony default export */ var _unused_webpack_default_export = AlertModule;

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_codes_const_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_admin_factory_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth_factory_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_bankid_factory_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_company_factory_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_company_subscription_factory_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_company_tenant_factory_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_config_provider_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_req_factory_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_mm_factory_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_payment_factory_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_payment_info_factory_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_share_factory_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_share_v2_factory_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_user_factory_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_user_notification_factory_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_user_tenant_factory_js__ = __webpack_require__(93);


















// kv.api
// -------------
//
// Wrapper module for kivras core API
//
// - [KvApiBankID](#kvapibankid)
// - [KvApiConfig](#kvapiconfig)
// - [KvApiUserNotification](#kvapiusernotification)
// - [KvApiPayment](#kvapipayment)
// - [KvApiShare](#kvapishare)
// - [KvApiShareV2](#kvapisharev2)
// - [KvApiUser](#kvapiuser)
// - [KvApi](#kvapi)
var ApiModule = angular.module('kv.api', ['LocalStorageModule']).constant('KvApiErrorLevels', __WEBPACK_IMPORTED_MODULE_0__api_codes_const_js__["a" /* ErrorLevels */]).factory('KvApi', __WEBPACK_IMPORTED_MODULE_8__api_req_factory_js__["a" /* KvApiFactory */]).factory('KvApiAdmin', __WEBPACK_IMPORTED_MODULE_1__api_admin_factory_js__["a" /* KvApiAdminFactory */]).factory('KvApiAuth', __WEBPACK_IMPORTED_MODULE_2__api_auth_factory_js__["a" /* KvApiAuthFactory */]).factory('KvApiBankID', __WEBPACK_IMPORTED_MODULE_3__api_bankid_factory_js__["a" /* KvApiBankIDFactory */]).factory('KvApiCompany', __WEBPACK_IMPORTED_MODULE_4__api_company_factory_js__["a" /* KvApiCompanyFactory */]).factory('KvApiCompanySubscription', __WEBPACK_IMPORTED_MODULE_5__api_company_subscription_factory_js__["a" /* KvApiCompanySubscriptionFactory */]).factory('KvApiCompanyTenant', __WEBPACK_IMPORTED_MODULE_6__api_company_tenant_factory_js__["a" /* KvApiCompanyTenantFactory */]).factory('KvApiMm', __WEBPACK_IMPORTED_MODULE_9__api_mm_factory_js__["a" /* KvApiMmFactory */]).factory('KvApiPayment', __WEBPACK_IMPORTED_MODULE_10__api_payment_factory_js__["a" /* KvApiPaymentFactory */]).factory('KvApiPaymentInfo', __WEBPACK_IMPORTED_MODULE_11__api_payment_info_factory_js__["a" /* KvApiPaymentInfoFactory */]).factory('KvApiShare', __WEBPACK_IMPORTED_MODULE_12__api_share_factory_js__["a" /* KvApiShareFactory */]).factory('KvApiShareV2', __WEBPACK_IMPORTED_MODULE_13__api_share_v2_factory_js__["a" /* KvApiShareV2Factory */]).factory('KvApiUser', __WEBPACK_IMPORTED_MODULE_14__api_user_factory_js__["a" /* KvApiUserFactory */]).factory('KvApiUserNotification', __WEBPACK_IMPORTED_MODULE_15__api_user_notification_factory_js__["a" /* KvApiUserNotificationFactory */]).factory('KvApiUserTenant', __WEBPACK_IMPORTED_MODULE_16__api_user_tenant_factory_js__["a" /* KvApiUserTenantFactory */]).provider('KvApiConfig', __WEBPACK_IMPORTED_MODULE_7__api_config_provider_js__["a" /* KvApiConfigProvider */]).name;

/* unused harmony default export */ var _unused_webpack_default_export = ApiModule;

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bankid_factory_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__device_device_module__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__querystring_querystring_module__ = __webpack_require__(42);




// kv.bankid
// -------------
//
// Module for opening bankid app
// Includes a bankid-factory that lets e.g a controller request opening of the bankID app
//
// - [BankId](#bankid)
var BankIdModule = angular.module('kv.bankid', [__WEBPACK_IMPORTED_MODULE_1__device_device_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__querystring_querystring_module__["a" /* default */]]).factory('KvBankId', __WEBPACK_IMPORTED_MODULE_0__bankid_factory_js__["a" /* BankIdFactory */]).name;

/* unused harmony default export */ var _unused_webpack_default_export = BankIdModule;

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__company_factory_js__ = __webpack_require__(95);


// kv.state
// --------
//
// Handles logic for applications using the angular ui-router
//
// - [KvCompanyFactory](#statefactory)
// - [StateParser](#stateparser)

var CompanyModule = angular.module('kv.company', []).factory('KvCompany', __WEBPACK_IMPORTED_MODULE_0__company_factory_js__["a" /* KvCompanyFactory */]);

/* unused harmony default export */ var _unused_webpack_default_export = CompanyModule;

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contents_provider_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_factory_js__ = __webpack_require__(96);



// kv.content
// --------------
//
// Kivra content business logic
// It's purpose is to abstracts away Core API:s JSON schema specifics
// and provide some aggregating utility functions and such
//
// - [kvContentFactory](#kvcontentfactory)
var ContentModule = angular.module('kv.content', []).provider('kvContents', __WEBPACK_IMPORTED_MODULE_0__contents_provider_js__["a" /* KvContentsProvider */]).factory('kvContent', __WEBPACK_IMPORTED_MODULE_1__content_factory_js__["a" /* kvContentFactory */]);

/* unused harmony default export */ var _unused_webpack_default_export = ContentModule;

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_dict_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_config_provider_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_factory_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_parser_factory_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_user_schema_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_validator_factory_js__ = __webpack_require__(105);







// kv.form
// -------------
//
// Kivra form uses [angular-schema-form](https://github.com/json-schema-form/angular-schema-form/blob/development/docs/index.md) to make creation of forms  in the service more
// DRY and declarative.
//
// - [KvFormDict](#formdict)
// - [KvFormConfig](#kvformconfig)
// - [KvUserSchema](#kvuserschema)
// - [KvFormParserFactory](#kvformparserfactory)
var FormModule = angular.module('kv.form', []).constant('KvFormDict', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__form_dict_js__["a" /* getFormDict */])()).factory('KvForm', __WEBPACK_IMPORTED_MODULE_2__form_factory_js__["a" /* kvFormFactory */]).factory('KvFormParserFactory', __WEBPACK_IMPORTED_MODULE_3__form_parser_factory_js__["a" /* parserFactory */]).factory('KvFormValidatorFactory', __WEBPACK_IMPORTED_MODULE_5__form_validator_factory_js__["a" /* validatorFactory */]).factory('KvUserSchema', __WEBPACK_IMPORTED_MODULE_4__form_user_schema_js__["a" /* userSchemaFactory */]).provider('KvFormConfig', __WEBPACK_IMPORTED_MODULE_1__form_config_provider_js__["a" /* kvFormConfigProvider */]);

/* unused harmony default export */ var _unused_webpack_default_export = FormModule;

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oauthclient_factory_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__oauthclient_interceptor_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__oauthclient_return_controller_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__oauthclient_routes_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__oauthclient_provider_js__ = __webpack_require__(108);






// kv.oauthclient
// --------------
//
// Manages a client applications OAuth2.0 session
//
// - [OAuthInterceptor](#oauthinterceptor)
// - [OAuthRoutesFactory](#oauthroutesfactory)
// - [OAuthFactory](#oauthfactory)
// - [OAuthReturnCtrl](#oauthreturnctrl)
// - [oauthclientConfig](#oauthclientconfig)
var OAuthClientModule = angular.module('kv.oauthclient', ['kv.querystring', 'kv.state', 'kv.session', 'LocalStorageModule']).controller('OAuthReturnCtrl', __WEBPACK_IMPORTED_MODULE_2__oauthclient_return_controller_js__["a" /* OAuthReturnCtrl */]).factory('OAuthInterceptor', __WEBPACK_IMPORTED_MODULE_1__oauthclient_interceptor_js__["a" /* OAuthInterceptor */]).factory('OAuthRoutesFactory', __WEBPACK_IMPORTED_MODULE_3__oauthclient_routes_js__["a" /* OAuthRoutesFactory */]).provider('OAuthFactory', __WEBPACK_IMPORTED_MODULE_0__oauthclient_factory_js__["a" /* OAuthFactoryProvider */]).provider('oauthclientConfig', __WEBPACK_IMPORTED_MODULE_4__oauthclient_provider_js__["a" /* OauthclientConfigProvider */]);

/* unused harmony default export */ var _unused_webpack_default_export = OAuthClientModule;

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__payment_factory_js__ = __webpack_require__(111);


// kv.payment
// -------------
//
// Business logic for managing payments
//
// - [KvPayment](#kvpayment)

var PaymentModule = angular.module('kv.payment', []).factory('KvPayment', __WEBPACK_IMPORTED_MODULE_0__payment_factory_js__["a" /* KvPaymentFactory */]);

/* unused harmony default export */ var _unused_webpack_default_export = PaymentModule;

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_controller_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_provider_js__ = __webpack_require__(114);



var RouterModule = angular.module('kv.router', ['ngRoute']).controller('KvRouterCtrl', __WEBPACK_IMPORTED_MODULE_0__router_controller_js__["a" /* KvRouterCtrl */]).provider('KvRouter', __WEBPACK_IMPORTED_MODULE_1__router_provider_js__["a" /* KvRouterProvider */]);

/* unused harmony default export */ var _unused_webpack_default_export = RouterModule;

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__session_factory_js__ = __webpack_require__(115);


// kv.session
// ---------
//
// Store session data in localstorage
//
// - [SessionFactory](#sessionfactory)

var SessionModule = angular.module('kv.session', ['LocalStorageModule']).factory('SessionFactory', __WEBPACK_IMPORTED_MODULE_0__session_factory_js__["a" /* SessionFactory */]);

/* unused harmony default export */ var _unused_webpack_default_export = SessionModule;

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_factory_js__ = __webpack_require__(116);


// kv.state
// --------
//
// Handles logic for applications using the angular ui-router
//
// - [StateFactory](#statefactory)
// - [StateParser](#stateparser)

var StateModule = angular.module('kv.state', []).factory('StateFactory', __WEBPACK_IMPORTED_MODULE_0__state_factory_js__["a" /* StateFactory */]).factory('StateParser', __WEBPACK_IMPORTED_MODULE_0__state_factory_js__["a" /* StateFactory */]); // soon to be deprecated :)

/* unused harmony default export */ var _unused_webpack_default_export = StateModule;

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tenant_factory_js__ = __webpack_require__(117);


// kv.state
// --------
//
// Handles logic for applications using the angular ui-router
//
// - [KvTenantFactory](#statefactory)
// - [StateParser](#stateparser)

var TenantModule = angular.module('kv.tenant', []).factory('KvTenant', __WEBPACK_IMPORTED_MODULE_0__tenant_factory_js__["a" /* KvTenantFactory */]);

/* unused harmony default export */ var _unused_webpack_default_export = TenantModule;

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_content_icon_dir_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_provider_js__ = __webpack_require__(119);



// kv.ui
// --------------
//
// Kivra UI components
//
// - [uiConfig](#uiConfig)
// - [contentIcon](#contentIcon)
var UIModule = angular.module('kv.ui', []).directive('contentIcon', __WEBPACK_IMPORTED_MODULE_0__ui_content_icon_dir_js__["a" /* contentIconDir */]).provider('uiConfig', __WEBPACK_IMPORTED_MODULE_1__ui_provider_js__["a" /* uiConfigProv */]);

/* unused harmony default export */ var _unused_webpack_default_export = UIModule;

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_phone_parser_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_redirect_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_semver_factory_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_vat_parser_js__ = __webpack_require__(123);





// kv.util
// -------
//
// Utility module
//
// - [SemVerFactory](#semverfactory)
// - [KvVatUtil](#vatutilfactory)
// - [UrlUtil](#vatutilfactory)

var UtilModule = angular.module('kv.util', []).factory('SemVerFactory', __WEBPACK_IMPORTED_MODULE_2__util_semver_factory_js__["a" /* SemVerFactory */]).factory('KvVatUtil', __WEBPACK_IMPORTED_MODULE_3__util_vat_parser_js__["a" /* VatUtilFactory */]).factory('KvPhoneUtil', __WEBPACK_IMPORTED_MODULE_0__util_phone_parser_js__["a" /* PhoneUtilFactory */]).factory('KvRedirect', __WEBPACK_IMPORTED_MODULE_1__util_redirect_js__["a" /* RedirectFactory */]);

/* unused harmony default export */ var _unused_webpack_default_export = UtilModule;

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertsCtrl; });
AlertsCtrl.$inject = ['AlertsFactory'];
// # AlertsCtrl
// Stupid controller



function AlertsCtrl(AlertsFactory) {
  'ngInject';

  this.alerts = AlertsFactory.alerts;
  this.remove = AlertsFactory.remove;
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetAlertsDict; });
// # AlertsDict
// Dict for harmonized alert messages through kivra services
// this is a map of kivra_cores `code` field in error response payloads



function GetAlertsDict() {
  'ngInject';

  return {
    '40004': 'Du har redan aktiverat din Kivra. Kontakta support@kivra.com så hjälper vi dig.',
    '40005': 'Fel format ifyllt för mobiltelefonnummer',
    '40006': 'Lösenordet måste bestå av minst 6 tecken varav minst en siffra och en bokstav.',
    '40007': 'Felaktig e-post.',
    '40009': 'Felaktigt personnummer.',
    '40013': 'Användaren har redan accepterat en delning från dig',
    '40019': 'Filen gick inte att ladda upp. Filen kan vara för stor eller ha fel filformat',
    '40020': 'Ogiltliga mottagaruppgifter. Kontrollera uppgifterna på de valda mottagarna',
    '401': 'Ett fel har uppstått. Logga in och prova igen eller kontakta support@kivra.com',
    '40101': 'Fel e-post eller lösenord. Vänligen försök igen.',
    '40105': 'Det gick inte att dela din Kivra till användaren',
    '40106': 'Det finns redan en Kivra med denna e-post registrerad. Kontakta support@kivra.com så hjälper vi dig.',
    '40108': 'Aktiveringskoden är felaktig (koden är personlig, skall bestå av 6 siffror och gäller endast i 3 månader).',
    '40109': 'En befintlig delning till användaren finns redan eller så är du blockerad',
    '40903': 'Du måste avsluta dina pågående betalningar innan du kan avsluta betaltjänsten',
    '40902': 'Din kivra är avaktiverad. Du måste återaktivera din kivra för att börja använda den här tjänsten',
    '42200': 'Ett fel har uppstått. Prova igen eller kontakta support@kivra.com',
    '40_GENERIC_ERROR': 'Ett fel har uppstått. Prova igen eller kontakta support@kivra.com',
    '50300': 'Tjänsten är tyvärr inte aktiverad.',
    '503_TEMPORARY': 'Tjänsten är inte tillgänglig för tillfället. Vi beklagar det och ber dig prova igen vid ett senare tillfälle.',
    'HTTP_STATUS_502': 'Det verkar vara problem med tjänsten just nu. Prova igen eller kontakta support@kivra.com',
    'HTTP_STATUS_504': 'Det verkar vara problem med att nå tjänsten just nu. Prova igen eller kontakta support@kivra.com',
    'HTTP_STATUS_ABORTED': 'Det verkar vara problem med anslutningen till tjänsten, kontrollera din anslutning till internet och försök igen. Om problemet kvarstår kontakta support@kivra.com'
  };
}

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kvAlert; });
kvAlert.$inject = ['AlertsFactory'];
// # KvAlert
// Directive to create a kivra alert component
// The component will present alerts once they are catched by
// the current scope



function kvAlert(AlertsFactory) {
  'ngInject';

  var TEMPLATE = ['<div role="alert"', 'ng-show="alert"', 'class="container-fluid alert alert-transparent alert-{{ alert.type }}"', 'ng-class="{ \'alert-pending\': alert.pending  }"', '>', '<div class="row">', '<div class="col-xs-12">', '<div class="alert-bar"></div>', '</div>', '</div>', '<div class="row">', '<div class="col-xs-12">', '<p ng-show="alert.title">', '<strong  >', '{{ alert.title }}', '</strong>', '</p>', '<span  ng-show="alert.body">', '{{ alert.body }}', '</span>', '</div>', '</div>', '</div>'].join('');

  return {
    template: TEMPLATE,
    restrict: 'E',
    transclude: true,
    link: function link(scope) {
      var EVENT = AlertsFactory.EVENT;
      scope.$on(EVENT.NEW, function (e, alert) {
        scope.alert = alert;
      });
      scope.$on(EVENT.CLEAR, function () {
        scope.alert = null;
      });
    }
  };
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertsFactory; });
AlertsFactory.$inject = ['AlertsDict'];
// # AlertsFactory
// Emits (i.e downwards through scope hierarchy) alert objects on a provided scope



function AlertsFactory(AlertsDict) {
  'ngInject';

  // event name constants

  var EVENT = {
    CLEAR: 'alert:clear',
    NEW: 'alert:new'
  };

  function _broadcast($scope, params) {
    $scope.$broadcast(EVENT.NEW, params);
  }

  function error($scope, params) {

    var err = {
      type: 'danger'
    };

    // Is the message preset in the error object or do we need to map it to a message
    if (
    // Aborted / timeouted request
    typeof params.status === 'number' && params.status === -1) {
      err.body = AlertsDict['HTTP_STATUS_ABORTED'];
    } else if (typeof params.body === 'string' && params.body.length > 0) {
      err.body = params.body;
      err.title = params.title;
    } else if (typeof params.status === 'number' && params.data !== null && AlertsDict[params.data.code]) {
      err.body = AlertsDict[params.data.code];
    } else if (typeof params.status === 'number' && AlertsDict['HTTP_STATUS_' + params.status]) {
      err.body = AlertsDict['HTTP_STATUS_' + params.status];
    } else {
      err.body = AlertsDict['40_GENERIC_ERROR'];
    }
    _broadcast($scope, err);
  }

  function success($scope, params) {
    params.type = 'success';
    _broadcast($scope, params);
  }

  function info($scope, params) {
    params.type = 'info';
    _broadcast($scope, params);
  }

  function warning($scope, params) {
    params.type = 'warning';
    _broadcast($scope, params);
  }

  function clear($scope) {
    $scope.$broadcast(EVENT.CLEAR);
  }

  var factory = {
    error: error,
    info: info,
    warning: warning,
    success: success,
    clear: clear,
    EVENT: EVENT
  };

  return factory;
}

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiAdminFactory; });
KvApiAdminFactory.$inject = ['KvApi', '$q'];
// KvApiAdmin
// -----------
// User application interaction wrapper methods to the KvApi factory



function KvApiAdminFactory(KvApi, $q) {
  'ngInject';

  var factory = {
    register: register
  };

  function register(ssn) {

    return $q(function (resolve, reject) {

      KvApi.post([KvApi.getBaseUrl(), 'user', 'onboard-signature'].join('/'), {
        ssn: ssn
      }).then(function (res) {
        resolve({
          key: res.headers('kivra-objkey'),
          auto_start_token: res.data.auto_start_token
        });
      }, reject);
    });
  }

  return factory;
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiAuthFactory; });

KvApiAuthFactory.$inject = ['KvApi', 'KvApiConfig', '$q'];
// KvApiAuth
// -----------
// User application interaction wrapper methods to the KvApi factory



function KvApiAuthFactory(KvApi, KvApiConfig, $q) {
  'ngInject';

  var factory = {
    authBankId: authBankId,
    authPwd: authPwd
  };

  var url = KvApi.getBaseUrl() + '/auth';

  function authBankId(cid, state, redirect, okey) {

    return auth(cid, state, redirect, {
      bankid_order_key: okey
    });
  }

  function authPwd(cid, state, redirect, uname, pwd) {

    return auth(cid, state, redirect, {
      user_name: uname,
      password: pwd
    });
  }

  function auth(cid, state, redirect, credentials) {

    var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, {
      grant_type: KvApiConfig.oauthGrantType,
      client_id: cid,
      state: state,
      redirect_uri: redirect
    }, credentials);

    return $q(function (resolve, reject) {
      KvApi.post(url, payload).then(function (res) {
        return resolve(res.data);
      }).catch(reject);
    });
  }

  return factory;
}

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiBankIDFactory; });
KvApiBankIDFactory.$inject = ['KvApi', 'KvApiConfig', '$q', '$timeout'];


// KvApiBankID
// -----------
// User application interaction wrapper methods to the KvApi factory

function KvApiBankIDFactory(KvApi, KvApiConfig, $q, $timeout) {
  'ngInject';

  var factory = {
    poll: poll,
    cancel: cancel,
    stop: stop,
    auth: auth
  };

  function cancel(pollPromise) {
    pollPromise._cancel();
  }

  function stop(pollPromise) {
    pollPromise._stop();
  }

  function auth(ssn) {
    return $q(function (resolve, reject) {
      KvApi.post([KvApi.getBaseUrl('v2'), 'bankid'].join('/'), {
        ssn: ssn
      }).then(function (res) {
        resolve({
          key: res.headers('kivra-objkey'),
          auto_start_token: res.data.auto_start_token
        });
      }, reject);
    });
  }

  function poll(orderKey) {

    var dfd = $q.defer();
    var promise = dfd.promise;

    promise._cancel = function cancelPoll() {
      if (promise._nextPoll) {
        $timeout.cancel(promise._nextPoll);
      }
      dfd.reject(KvApi.errParser({
        data: {
          status: 'user_cancel'
        },
        // for backwards comp
        status: 'manually_cancelled',
        message_code: 'RFA6'
      }));
    };

    promise._stop = function stopPoll() {
      if (promise._nextPoll) {
        $timeout.cancel(promise._nextPoll);
      }
      dfd.reject(KvApi.errParser({
        data: {
          status: 'user_cancel'
        },
        // for backwards comp
        status: 'manually_stopped',
        message_code: 'RFA13'
      }));
    };

    function doPoll() {
      promise._nextPoll = $timeout(pollApi, KvApiConfig.bankidPollFreq, false);
    }

    function pollApi() {
      KvApi.get([KvApi.getBaseUrl('v2'), 'bankid', orderKey].join('/')).then(onResponse).catch(function (err) {
        // if req is timed-out or aborted we keep on polling
        // i.e faking a backend pending response
        // wishing for a better day
        if (err.status === -1) {
          onResponse({
            data: {
              status: 'pending',
              progress_status: 'lost_connection',
              message_code: 'CONN_ISSUE'
            }
          });
        } else {
          dfd.reject(err);
        }
      });
    }

    function onResponse(res) {

      var actions = {
        'pending': function notifyPending(data) {
          dfd.notify(data);
          // continue polling
          doPoll();
        },
        'complete': function resolveComplete() {
          dfd.resolve(orderKey);
        },
        'error': function rejectError(data) {
          dfd.reject(data);
        }
      };

      actions[res.data.status](res.data);
    }

    // Start recursive polling
    doPoll();

    return promise;
  }

  return factory;
}

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiCompanyFactory; });

KvApiCompanyFactory.$inject = ['KvApi', '$q'];


// # KvApiCompanyFactory

function KvApiCompanyFactory(KvApi, $q) {
  'ngInject';

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
    deleteUser: deleteUser,
    get: get,
    getContent: getContent,
    getPermission: getPermission,
    initOffboard: initOffboard,
    initOnboard: initOnboard,
    offboard: offboard,
    onboard: onboard,
    setPermission: setPermission,
    setPermissionItem: setPermissionItem,
    _getResKey: _getResKey
  });

  function _getResKey(coKey) {
    return ['company.', coKey].join('');
  }

  function setPermissionItem(permissions, actor, payload) {
    angular.extend(permissions.find(function (permission) {
      return permission.key === actor;
    }), payload);
    return permissions;
  }

  // Get company object
  function get(coKey) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$forceUpdate = _ref.forceUpdate,
        forceUpdate = _ref$forceUpdate === undefined ? false : _ref$forceUpdate;

    return $q(function (resolve, reject) {
      return KvApi.getResource({
        url: _url(coKey),
        resource: _getResKey(coKey),
        forceUpdate: forceUpdate
      }).then(resolve).catch(reject);
    });
  }

  // Get company permission object.
  function getPermission(coKey, actor) {
    return $q(function (resolve, reject) {
      KvApi.get(_url(coKey, 'permissions', actor), {}).then(function (res) {
        resolve(res.data);
      }).catch(reject);
    });
  }

  // Put company permission object.
  function setPermission(coKey, actor, payload) {
    return $q(function (resolve, reject) {
      KvApi.put(_url(coKey, 'permissions', actor), payload).then(function (res) {
        var sessionData = KvApi.getCachedResource(_getResKey(coKey));
        if (sessionData) {
          setPermissionItem(sessionData.permissions, actor, payload);
          KvApi.setCachedResource(_getResKey(coKey), sessionData);
        }
        resolve(res.data);
      }).catch(reject);
    });
  }

  // Delete company authorized user
  function deleteUser(coKey, actor) {
    return $q(function (resolve, reject) {
      KvApi.del(_url(coKey, 'permissions', actor), {}).then(function (res) {
        KvApi.setCachedResource(_getResKey(coKey), res.data);
        resolve(res.data);
      }).catch(reject);
    });
  }

  // Get company content object.
  function getContent(coKey) {
    var url = [KvApi.getBaseUrl('v2'), 'company', coKey, 'content'].join('/');

    return $q(function (resolve, reject) {
      return KvApi.get(url).then(function (res) {
        return resolve(res.data);
      }).catch(reject);
    });
  }

  // Onboard company
  function initOnboard(vat, ssn) {
    return $q(function (resolve, reject) {
      KvApi.post(_url('onboard-signature'), {
        vat_number: vat,
        ssn: ssn
      }).then(function (res) {
        return resolve(res.data);
      }).catch(reject);
    });
  }

  function onboard(vat, orderKey) {
    return $q(function (resolve, reject) {
      KvApi.post(_url(), {
        vat_number: vat,
        bankid_order_key: orderKey
      }).then(function (res) {
        var updatedCompany = res.data;
        KvApi.setCachedResource(_getResKey(res.headers('kivra-objkey'), updatedCompany));
        resolve(updatedCompany);
      }).catch(reject);
    });
  }

  // Offboard company
  function initOffboard(vat, ssn) {
    return $q(function (resolve, reject) {
      KvApi.post(_url('offboard-signature'), {
        vat_number: vat,
        ssn: ssn
      }).then(function (res) {
        return resolve(res.data);
      }).catch(reject);
    });
  }

  function offboard(coKey, orderKey) {
    return $q(function (resolve, reject) {
      KvApi.post(_url(coKey, 'offboard-company'), {
        bankid_order_key: orderKey
      }).then(function (res) {
        var updatedCompany = res.data;
        KvApi.setCachedResource(_getResKey(coKey), updatedCompany);
        resolve(updatedCompany);
      }).catch(reject);
    });
  }

  // Build url on default base path.
  function _url() {
    for (var _len = arguments.length, subPath = Array(_len), _key = 0; _key < _len; _key++) {
      subPath[_key] = arguments[_key];
    }

    return [KvApi.getBaseUrl('v2'), 'company'].concat(subPath).join('/');
  }
}

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiCompanySubscriptionFactory; });


KvApiCompanySubscriptionFactory.$inject = ['KvApi', '$q'];


// # KvApiCompanySubscriptionFactory

function KvApiCompanySubscriptionFactory(KvApi, $q) {
  'ngInject';

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
    getPaymentInfo: getPaymentInfo,
    getStatus: getStatus,
    initOnboard: initOnboard,
    offboard: offboard,
    onboard: onboard,
    setScanningAddress: setScanningAddress,
    updatePaymentInfo: updatePaymentInfo
  });

  function _getResKey(coKey) {
    return ['company.', coKey].join('');
  }

  function getStatus(coKey) {
    var url = KvApi.getBaseUrl('v2') + '/company/' + coKey + '/subscriptions/kivra_plus';

    return $q(function (resolve, reject) {
      KvApi.get(url).then(function (res) {
        resolve(res.data);
      }).catch(reject);
    });
  }

  function updatePaymentInfo(coKey, token_id, cardholder_name, credit_card_id, last4) {
    var url = KvApi.getBaseUrl('v2') + '/company/' + coKey + '/payment_info';

    var payload = { token_id: token_id, cardholder_name: cardholder_name, credit_card_id: credit_card_id, last4: last4 };
    return $q(function (resolve, reject) {
      KvApi.put(url, payload).then(function (res) {
        resolve(res.data);
      }).catch(reject);
    });
  }

  function getPaymentInfo(coKey) {
    var url = KvApi.getBaseUrl('v2') + '/company/' + coKey + '/payment_info';

    return $q(function (resolve, reject) {
      KvApi.get(url).then(function (res) {
        resolve(res.data);
      }).catch(reject);
    });
  }

  function initOnboard(coKey) {
    var url = KvApi.getBaseUrl('v2') + '/company/' + coKey + '/subscriptions/kivra_plus';

    var payload = { state: 'init_onboard' };
    return $q(function (resolve, reject) {
      KvApi.put(url, payload).then(function (res) {
        resolve(res.data);
      }).catch(reject);
    });
  }

  /**
   * @desc This api is meant to be called when kivra_plus state is set to
   *    init_onboard or active_ending.
   * @param {string} coKey
   * @param {?Object} tokenizedCredentials Parameter should only be passed
   *    if going from init_onboard to active_ongoing.
   * @return {Promise}
   */
  function onboard(coKey, tokenizedCardCredentials) {
    var url = KvApi.getBaseUrl('v2') + '/company/' + coKey + '/subscriptions/kivra_plus';

    var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ state: 'active_ongoing' }, tokenizedCardCredentials ? { payload: tokenizedCardCredentials } : null);
    return $q(function (resolve, reject) {
      KvApi.put(url, payload).then(function (res) {
        var objKey = _getResKey(coKey);
        var company = KvApi.getCachedResource(objKey);
        if (company) {
          company.subscriptions.kivra_plus = res.data;
          KvApi.setCachedResource(objKey, company);
        }
        resolve(res.data);
      }).catch(reject);
    });
  }

  function offboard(coKey) {
    var url = KvApi.getBaseUrl('v2') + '/company/' + coKey + '/subscriptions/kivra_plus';

    var payload = { state: 'active_ending' };
    return $q(function (resolve, reject) {
      KvApi.put(url, payload).then(function (res) {
        var objKey = _getResKey(coKey);
        var company = KvApi.getCachedResource(objKey);
        if (company) {
          company.subscriptions.kivra_plus = res.data;
          KvApi.setCachedResource(objKey, company);
        }
        resolve(res.data);
      }).catch(reject);
    });
  }

  function setScanningAddress(coKey, payload) {
    var url = KvApi.getBaseUrl('v2') + '/company/' + coKey + '/services/scanning';

    return $q(function (resolve, reject) {
      KvApi.put(url, payload).then(function (res) {
        resolve(res.data);
      }).catch(reject);
    });
  }
}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiCompanyTenantFactory; });


KvApiCompanyTenantFactory.$inject = ['$q', 'KvApi'];


// KvApiCompanyTenantFactory
// -----------
// User application interaction wrapper methods to the KvApiCompanyTenantFactory factory
function KvApiCompanyTenantFactory($q, KvApi) {
  'ngInject';

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
    get: get,
    initOffboard: initOffboard,
    initOnboard: initOnboard,
    offboard: offboard,
    onboard: onboard
  });

  /**
   *  Returns a company tenants list or one tenant if tenant_key is supplied.
   *  @param  {string} coKey
   *  @param  {string=} tKey
   *  @return {Promise}
   */
  function get(coKey, tKey) {
    var url = tKey ? KvApi.getBaseUrl('v2') + '/company/' + coKey + '/tenant/' + tKey : KvApi.getBaseUrl('v2') + '/company/' + coKey + '/tenant';

    return $q(function (resolve, reject) {
      if (tKey) {
        KvApi.get(url).then(function (res) {
          resolve(res.data);
        }, reject);
      } else {
        var sessionData = KvApi.getCachedResource(_getPrefix(coKey));
        if (sessionData) {
          resolve(sessionData);
        } else {
          KvApi.get(url).then(function (res) {
            KvApi.setCachedResource(_getPrefix(coKey), res.data);
            resolve(res.data);
          }, reject);
        }
      }
    });
  }

  /**
   *  @param  {string} coKey
   *  @param  {string} tKey
   *  @param  {string} ssn
   *  @return {Promise.<{{ bankid_order_key: string }}>}
   */
  function initOnboard(coKey, tKey, ssn) {
    var url = KvApi.getBaseUrl('v2') + '/company/' + coKey + '/mm/onboard-tenant-signature';
    var payload = { tenant_key: tKey, ssn: ssn };

    return $q(function (resolve, reject) {
      KvApi.post(url, payload).then(function (res) {
        return resolve(res.data);
      }).catch(reject);
    });
  }

  /**
   *  @param  {string} coKey
   *  @param  {string} tKey
   *  @param  {string=} orderKey
   *  @return {Promise}
   */
  function onboard(coKey, tKey, orderKey) {
    var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ state: 'accept' }, orderKey ? { bankid_order_key: orderKey } : null);

    return setState(coKey, tKey, payload);
  }

  /**
   *  @param  {string} coKey
   *  @param  {string} tKey
   *  @param  {string} ssn
   *  @return {Promise.<{{ bankid_order_key: string }}>}
   */
  function initOffboard(coKey, tKey, ssn) {
    var url = KvApi.getBaseUrl('v2') + '/company/' + coKey + '/mm/offboard-tenant-signature';
    var payload = { tenant_key: tKey, ssn: ssn };

    return $q(function (resolve, reject) {
      KvApi.post(url, payload).then(function (res) {
        return resolve(res.data);
      }).catch(reject);
    });
  }

  /**
   *  @param  {string} coKey
   *  @param  {string} tKey
   *  @param  {string=} orderKey
   *  @return {Promise}
   */
  function offboard(coKey, tKey, orderKey) {
    var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ state: 'reject' }, orderKey ? { bankid_order_key: orderKey } : null);

    return setState(coKey, tKey, payload);
  }

  /**
   *  @param  {string} coKey
   *  @param  {string} tKey
   *  @param  {Object} payload
   *  @return {Promise}
   */
  function setState(coKey, tKey, payload) {
    var url = KvApi.getBaseUrl('v2') + '/company/' + coKey + '/tenant/' + tKey + '/state';

    return $q(function (resolve, reject) {
      KvApi.put(url, payload).then(function (res) {
        updateTenantStateCache(coKey, tKey, payload.state);
        resolve(res.data);
      }).catch(reject);
    });
  }

  /**
   *  @param  {string} coKey
   *  @param  {string} tKey
   *  @param  {string} state
   *  @return {Promise}
   */
  function updateTenantStateCache(coKey, tKey, state) {
    var sessionData = KvApi.getCachedResource(_getPrefix(coKey));
    if (sessionData) {
      sessionData.find(function (tenant) {
        return tenant.key === tKey;
      }).state = state;
      KvApi.setCachedResource(_getPrefix(coKey), sessionData);
    }
  }

  function _getPrefix(coKey) {
    return ['company.', coKey, '.tenants'].join('');
  }
}

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiConfigProvider; });


// # KvApiConfig
// Makes the coreApi module configurable
function KvApiConfigProvider() {
  'ngInject';

  // defaults

  var config = {
    coreHost: 'https://api.kivra.com',
    mmSupplierId: '165568402266',
    apiVersion: 'v1',
    oauthGrantType: 'implicit',
    harmonizedRejects: false,
    bankidPollFreq: 2000 // recommendation from BankID?
  };

  var provider = {
    set: function set(opt) {
      config = angular.extend(config, opt);
    },
    $get: function $get() {
      return config;
    }
  };
  return provider;
}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_array_find__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_fn_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_codes_const__ = __webpack_require__(43);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kvApiErrorParser; });
// KvApiErrorService
// -----------
// Harmonize API req errors





function kvApiErrorParser(err) {

  // err-identifiers assume that data key is available
  var data = function data(err) {
    return err.data ? err.data : {};
  };

  // return err object if error can be presented by a certain category
  var errBankId = function errBankId(err) {
    return __WEBPACK_IMPORTED_MODULE_1__api_codes_const__["b" /* BankIdErrors */][data(err).status] || null;
  };
  var errInput = function errInput(err) {
    return data(err).keys ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_codes_const__["c" /* getInputError */])(data(err)) : null;
  };
  var errCore = function errCore(err) {
    return data(err).code ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_codes_const__["d" /* getCoreError */])(data(err), err.status) : null;
  };
  var errHttp = function errHttp(err) {
    return __WEBPACK_IMPORTED_MODULE_1__api_codes_const__["e" /* HttpErrors */][err.status] || null;
  };
  var errDefault = function errDefault() {
    return __WEBPACK_IMPORTED_MODULE_1__api_codes_const__["f" /* DefaultError */];
  };

  // descending specificity
  var errPipe = [errBankId, errInput, errCore, errHttp, errDefault];

  var coreApiErr = errPipe.find(function (el) {
    return el(err);
  })(err);

  return coreApiErr;
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiMmFactory; });
KvApiMmFactory.$inject = ['KvApi', 'KvApiConfig', '$q'];


// KvApiMm
// -----------
// All MM management per user

function KvApiMmFactory(KvApi, KvApiConfig, $q) {
  'ngInject';

  var factory = {
    // Gets users MM account information
    get: get,
    // Initiate setting kivra as MM supplier
    initOnboard: initOnboard,
    // Initiate removal kivra as MM supplier
    initOffboard: initOffboard,
    // Set kivra as MM supplier
    onboard: onboard,
    // Remove Kivra as MM supplier
    offboard: offboard,
    // Starts BankID order for accepting a specific MM tenant
    offboardTenant: offboardTenant,
    // Starts BankID order for rejecting a specific MM tenant
    onboardTenant: onboardTenant,
    // Check wether user has Kivra as MM supplier or not
    isOnboarded: isOnboarded
  };

  function onboardTenant(ukey, tkey) {
    return _changeState(ukey, tkey, 'onboard');
  }

  function offboardTenant(ukey, tkey) {
    return _changeState(ukey, tkey, 'offboard');
  }

  function initOnboard(ukey) {
    return _initSet(ukey, 'onboard-signature');
  }

  function initOffboard(ukey) {
    return _initSet(ukey, 'offboard-signature');
  }

  function onboard(ukey, okey) {
    return _set(ukey, okey, {
      id: KvApiConfig.mmSupplierId
    });
  }

  function offboard(ukey, okey) {
    return _set(ukey, okey, null);
  }

  function get(ukey) {
    return $q(function (resolve, reject) {

      var sessionData = KvApi.getCachedResource(_getPrefix(ukey));

      if (sessionData) {
        resolve(sessionData);
      } else {
        KvApi.get(_url(ukey, 'account')).then(function (res) {
          _setLocal(ukey, res.data);
          resolve(res.data);
        }).catch(function (err) {
          switch (err.status) {
            // user just doesn't have an account
            case 404:
              _setLocal(ukey, err.data);
              resolve(err.data);
              break;
            default:
              reject(err);
          }
        });
      }
    });
  }

  function isOnboarded(account) {
    try {
      return !!account.serviceSupplier && account.serviceSupplier.id === KvApiConfig.mmSupplierId;
    } catch (e) {
      throw new Error('isOnboarded check failed: ' + e.toString());
    }
  }

  function _initSet(ukey, action) {
    return $q(function (resolve, reject) {
      KvApi.post(_url(ukey, action), {}).then(function (res) {
        res.data.key = res.headers('kivra-objkey');
        resolve(res.data);
      }).catch(reject);
    });
  }

  function _set(ukey, okey, supplier) {
    return $q(function (resolve, reject) {
      KvApi.put(_url(ukey, 'account'), {
        bankid_order_key: okey,
        serviceSupplier: supplier
      }).then(function (res) {
        _setLocal(ukey, res.data);
        resolve(res.data);
      }).catch(reject);
    });
  }

  function _setLocal(ukey, data) {
    KvApi.setCachedResource(_getPrefix(ukey), data);
  }

  function _changeState(ukey, tkey, action) {
    return $q(function (resolve, reject) {
      KvApi.post(_url(ukey, action + '-tenant-signature'), {
        tenant_key: tkey
      }).then(function (res) {
        resolve({
          key: res.headers('kivra-objkey'),
          auto_start_token: res.data.auto_start_token
        });
      }, reject);
    });
  }

  function _url(ukey, subPath) {
    return [KvApi.getBaseUrl(), 'user', ukey, 'mm'].concat(subPath).join('/');
  }

  function _getPrefix(ukey) {
    return 'user.' + ukey + '.mm';
  }

  return factory;
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiPaymentFactory; });
KvApiPaymentFactory.$inject = ['KvApi'];


// # KvApiPayment
// Factory to wrap http interactions to the Pacioli parts of Kivra's API

function KvApiPaymentFactory(KvApi) {
  'ngInject';

  var factory = {
    get: get,
    fetch: fetchit,
    cached: cached
  };

  // `fetch({String})`
  //
  // Fetch always requests resource from API and puts it in cache for future gets
  function fetchit(ukey) {
    return KvApi.fetchResource({
      url: _getUrl(ukey),
      resource: _getKey(ukey)
    });
  }

  // `get({String})`
  //
  // Get uses cached resource if available
  function get(ukey) {
    return KvApi.getResource({
      url: _getUrl(ukey),
      resource: _getKey(ukey)
    });
  }

  // `cached({String})`
  //
  //  Get cached resource (this will throw if no cache exists)
  function cached(ukey) {
    return KvApi.getCachedResource(_getKey(ukey));
  }

  function _getKey(ukey) {
    return ['user', ukey, 'payments'].join('.');
  }

  // - ukey: user key
  // - extras: OPTIONAL Array of subpaths to append to url
  function _getUrl(ukey, extras) {

    var path = [KvApi.getBaseUrl(), 'user', ukey, 'payment'];

    path = extras && extras.length > 0 ? path.join(extras) : path;

    return path.join('/');
  }

  return factory;
}

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiPaymentInfoFactory; });

KvApiPaymentInfoFactory.$inject = ['KvApi', '$q'];


// # KvApiCompanyFactory

function KvApiPaymentInfoFactory(KvApi, $q) {
  'ngInject';

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
    get: get
  });

  // Get payment info object
  function get(uKey) {
    return $q(function (resolve, reject) {
      return KvApi.getResource({
        url: url(uKey, 'payment_info'),
        resource: resId(uKey)
      }).then(resolve).catch(reject);
    });
  }

  function resId(uKey) {
    return 'user.' + uKey + '.payment_info';
  }

  // Build url on default base path.
  function url() {
    for (var _len = arguments.length, subPath = Array(_len), _key = 0; _key < _len; _key++) {
      subPath[_key] = arguments[_key];
    }

    return [KvApi.getBaseUrl('v1'), 'user'].concat(subPath).join('/');
  }
}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_error_service__ = __webpack_require__(84);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiFactory; });
KvApiFactory.$inject = ['$http', '$q', 'localStorageService', 'KvApiConfig'];



// # KvApi
// Utility functions to wrap api requests in promises
// and manage cached responses etc
function KvApiFactory($http, $q, localStorageService, KvApiConfig) {
  'ngInject';

  // public methods
  // not sure how to freeze object since we add jasmine spies on it

  var factory = {
    get: get,
    post: post,
    put: put,
    del: del,
    errParser: errParser,
    getBaseUrl: getBaseUrl,
    getResource: getResource,
    deleteResource: deleteResource,
    fetchResource: fetchResource,
    updateResource: updateResource,
    clearCache: clearCache,
    getCachedResource: getCachedResource,
    setCachedResource: setCachedResource,
    createResource: createResource
  };

  var PREFIX = 'kv.api.';

  function getBaseUrl(apiVersion) {
    return [KvApiConfig.coreHost, apiVersion || KvApiConfig.apiVersion].join('/');
  }

  function getCachedResource(resource) {
    return localStorageService.get(PREFIX + resource);
  }

  function setCachedResource(resource, val) {
    localStorageService.set(PREFIX + resource, val);
  }

  function clearCache() {
    localStorageService.clearAll(/.*kv\.api.*/);
  }

  function createResource(opt, payload) {
    return _changeResource('post', payload, opt);
  }

  function updateResource(opt, payload) {
    return _changeResource('put', payload, opt);
  }

  function fetchResource(opt) {
    return getResource(angular.extend({
      forceUpdate: true
    }, opt));
  }

  // we dont want other factories in this module to have a $http dependency
  function get(url) {
    return makeReq('get', url);
  }

  function post(url, payload) {
    return makeReq('post', url, payload);
  }

  function put(url, payload) {
    return makeReq('put', url, payload);
  }

  function del(url) {
    return makeReq('delete', url);
  }

  function errParser(err) {
    var rejectErr = KvApiConfig.harmonizedRejects ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_error_service__["a" /* kvApiErrorParser */])(err) : err;
    return rejectErr;
  }

  function makeReq(method, url) {
    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


    return $q(function (resolve, reject) {
      $http[method](url, payload).then(resolve).catch(function (err) {
        return reject(errParser(err));
      });
    });
  }

  function getResource(opt) {

    return $q(function (resolve, reject) {

      var cached = getCachedResource(opt.resource);
      if (!opt.forceUpdate && cached) {
        resolve(cached);
      } else {
        get(opt.url).then(function (res) {
          if (opt.resource) {
            setCachedResource(opt.resource, res.data);
          }
          resolve(res.data);
        }).catch(reject);
      }
    });
  }

  function deleteResource(opt) {

    return $q(function (resolve, reject) {
      del(opt.url).then(function (res) {
        if (opt.resource) {
          setCachedResource(opt.resource, null);
        }
        resolve(res.data);
      }).catch(reject);
    });
  }

  function augmentKey(res) {
    if (res.config.method !== 'POST') {
      return false;
    }
    if (res.status !== 201) {
      return false;
    }
    if (!(res.data instanceof Object)) {
      return false;
    }
    if (res.data.hasOwnProperty('key')) {
      return false;
    }
    return true;
  }

  function _changeResource(method, payload, opt) {
    return $q(function (resolve, reject) {
      makeReq(method, opt.url, payload).then(function (res) {
        if (augmentKey(res)) {
          var key = res.headers('kivra-objkey');
          if (key) {
            res.data.key = key;
          }
        }
        if (opt.resource) {
          setCachedResource(opt.resource, res.data);
        }
        resolve(res.data);
      }).catch(reject);
    });
  }

  return factory;
}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiShareFactory; });
KvApiShareFactory.$inject = ['KvApi', 'KvApiUser', '$q'];


// KvApiShare
// -----------
// User application interaction wrapper methods to the KvApi factory

function KvApiShareFactory(KvApi, KvApiUser, $q) {
  'ngInject';

  var factory = {
    cached: cached,
    filter: filter,
    invite: invite,
    accept: accept,
    fetch: fetchit,
    getDirection: getDirection,
    delete: deleteit
  };

  // Get uses cached resource if available
  function cached(ukey) {
    return KvApi.getCachedResource(_getPrefix(ukey));
  }

  function fetchit(ukey) {

    var dfd = $q.defer();
    var shares;

    // omg backend API is so ugly but we have to make it nice for our clients
    KvApi.fetchResource({
      url: KvApiUser.getUrl(ukey) + '/share'
    }).then(function (res) {
      shares = res;
      return KvApi.fetchResource({
        url: KvApiUser.getUrl(ukey) + '/sendrequest?include=body&state=pending'
      });
    }).then(function (res) {
      // put them all together
      shares = shares.concat(res);
      KvApi.setCachedResource(_getPrefix(ukey), shares);
      dfd.resolve(shares);
    }).catch(function (err) {
      dfd.reject(err);
    });

    return dfd.promise;
  }

  function getDirection(share, ukey) {
    if (share.hasOwnProperty('direction')) {
      return share.direction;
    }
    if (share.sender.match(ukey)) {
      return 'out';
    }
    return 'in';
  }

  function filter(category, ukey, shares) {
    return shares.filter(function (share) {
      return getDirection(share, ukey) === category;
    });
  }

  function accept(ukey, key, code) {

    var dfd = $q.defer();

    KvApi.updateResource({
      url: [KvApiUser.getUrl(ukey), 'sendrequest', key, 'status'].join('/')
    }, {
      state: 'accept',
      key: key,
      registration_code: code
    }).then(function () {
      // The sendreq (data) became a share but what do we know about that?!
      dfd.resolve(key);
    }).catch(dfd.reject);

    return dfd.promise;
  }

  function deleteit(ukey, share) {
    // check if share or srq
    var type = share.hasOwnProperty('direction') ? 'share' : 'sendrequest';

    var dfd = $q.defer();

    KvApi.deleteResource({
      url: [KvApiUser.getUrl(ukey), type, share.key].join('/')
    }).then(function () {
      // remove deleted share from cache list
      var updated = KvApi.getCachedResource(_getPrefix(ukey));
      updated.some(function (obj, index, arr) {
        if (obj.key === share.key) {
          arr.splice(index, 1);
        }
      });

      _updateCache(ukey, updated);
      dfd.resolve(updated);
    }).catch(dfd.reject);

    return dfd.promise;
  }

  function invite(ukey, data) {

    var dfd = $q.defer();

    KvApi.createResource({
      url: KvApiUser.getUrl(ukey) + '/sendrequest'
    }, data).then(function (srq) {

      // update cache
      _updateCache(ukey, KvApi.getCachedResource(_getPrefix(ukey)).concat([srq]));

      // resolve created srq
      dfd.resolve(srq);
    }).catch(dfd.reject);

    return dfd.promise;
  }

  function _updateCache(ukey, updated) {
    KvApi.setCachedResource(_getPrefix(ukey), updated);
  }

  function _getPrefix(ukey) {
    return 'user.' + ukey + '.shares';
  }

  return factory;
}

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiShareV2Factory; });

KvApiShareV2Factory.$inject = ['KvApi'];


// KvApiShareV2
// -----------
// User application interaction wrapper methods to the KvApi factory

function KvApiShareV2Factory(KvApi) {
  'ngInject';

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
    get: getShares,
    create: createShare,
    update: updateShare,
    remove: removeShare
  });

  function _getResKey(atype, akey, skey) {
    return [atype, akey, skey];
  }

  function _url(atype, akey, skey) {
    return [KvApi.getBaseUrl('v2'), atype, akey, 'share', skey].join('/');
  }

  function getShares(atype, akey) {
    return KvApi.getResource({
      url: _url(atype, akey),
      resource: _getResKey(atype, akey)
    });
  }

  function createShare(atype, akey, share) {
    return KvApi.createResource({ url: _url(atype, akey) }, share);
  }

  function updateShare(atype, akey, skey, share) {
    return KvApi.updateResource({ url: _url(atype, akey, skey) }, share);
  }

  function removeShare(atype, akey, skey) {
    return KvApi.deleteResource({
      url: _url(atype, akey, skey)
    });
  }
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiUserFactory; });
KvApiUserFactory.$inject = ['KvApi', '$q'];


// KvApiUser
// -----------
// User application interaction wrapper methods to the KvApi factory

function KvApiUserFactory(KvApi, $q) {
  'ngInject';

  var PREFIX = 'user.';

  var factory = {
    get: get,
    fetch: fetchit,
    cached: cached,
    hasPassword: hasPassword,
    isDeactivated: isDeactivated,
    update: update,
    deactivate: deactivate,
    activate: activate,
    getUrl: getUrl
  };

  function getUrl(ukey) {
    return [KvApi.getBaseUrl(), 'user', ukey].join('/');
  }

  // Get cached resource (this will throw if no cache exists)
  function cached(ukey) {
    return KvApi.getCachedResource(PREFIX + ukey);
  }

  // Get uses cached resource if available
  function get(ukey) {
    return KvApi.getResource(_getUserOpt(ukey));
  }

  // Fetch always requests resource from API
  function fetchit(ukey) {
    return KvApi.fetchResource(_getUserOpt(ukey));
  }

  function hasPassword(user) {
    return user.identification_type !== 'bankid';
  }

  function isDeactivated(user) {
    return user.deactivate.state === 'true';
  }

  function activate(ukey) {
    return _setUserState(ukey, 'active');
  }

  function deactivate(ukey) {
    return _setUserState(ukey, 'deactive');
  }

  function update(ukey, user) {
    return KvApi.updateResource(_getUserOpt(ukey), user);
  }

  function _setUserState(ukey, state) {

    var dfd = $q.defer();

    var states = {
      'active': {
        action: 'activate',
        deactivate: 'false'
      },
      'deactive': {
        action: 'deactivate',
        deactivate: 'true'
      }
    };

    KvApi.updateResource({
      url: getUrl(ukey) + '/state'
    }, {
      state: states[state].action
    }).then(function () {

      var resourceKey = PREFIX + ukey;
      var user = angular.extend({}, KvApi.getCachedResource(resourceKey), {
        deactivate: {
          state: states[state].deactivate,
          date: new Date().toJSON()
        }
      });

      KvApi.setCachedResource(resourceKey, user);

      dfd.resolve(user);
    });

    return dfd.promise;
  }

  function _getUserOpt(ukey) {
    return {
      url: getUrl(ukey),
      resource: PREFIX + ukey
    };
  }

  return factory;
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiUserNotificationFactory; });
KvApiUserNotificationFactory.$inject = ['KvApi', '$q'];


/**
 *  KvApiUserNotificationFactory
 *  -----------
 *  User Notification application interaction wrapper
 *  methods to the KvApi factory.
 */

function KvApiUserNotificationFactory(KvApi, $q) {
  'ngInject';

  var factory = {
    get: get,
    setState: setState
  };

  /**
   *  @param  {String} ukey
   *  @return {Object} $q Promise.
   */
  function get(ukey) {
    return $q(function (resolve, reject) {

      KvApi.get(_url(ukey)).then(function (res) {
        resolve(res.data);
      }).catch(reject);
    });
  }

  /**
   *  @param  {String} ukey
   *  @param  {Object} payload
   *  @return {Object} $q Promise.
   */
  function setState(ukey, payload) {
    return $q(function (resolve, reject) {
      KvApi.put(_url(ukey), payload).then(function (res) {
        resolve(res.data);
      }).catch(reject);
    });
  }

  function _url(ukey) {
    return [KvApi.getBaseUrl('v2'), 'user', ukey, 'notification_settings'].join('/');
  }

  return factory;
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvApiUserTenantFactory; });
KvApiUserTenantFactory.$inject = ['$q', 'KvApi'];


// KvApiUserTenantFactory
// -----------
// User application interaction wrapper methods to the KvApiUserTenantFactory factory
function KvApiUserTenantFactory($q, KvApi) {
  'ngInject';

  function get(ukey) {

    return $q(function (resolve, reject) {
      var sessionData = KvApi.getCachedResource(_getPrefix(ukey));
      if (sessionData) {
        resolve(sessionData);
      } else {
        KvApi.get([KvApi.getBaseUrl(), 'user', ukey, 'tenant'].join('/')).then(function (res) {
          KvApi.setCachedResource(_getPrefix(ukey), res.data);
          resolve(res.data);
        }, reject);
      }
    });
  }

  function getOne(tkey, ukey) {

    return $q(function (resolve, reject) {
      var sessionData = KvApi.getCachedResource(_getPrefix(ukey));
      if (sessionData) {
        sessionData.some(function (tenant) {
          if (tenant.key === tkey) {
            resolve(tenant);
          }
        });
      } else {
        KvApi.get([KvApi.getBaseUrl(), 'user', ukey, 'tenant', tkey].join('/')).then(function (res) {
          resolve(res.data);
        }).catch(reject);
      }
    });
  }

  function setState(tkey, ukey, payload) {

    return $q(function (resolve, reject) {
      KvApi.put([KvApi.getBaseUrl('v2'), 'user', ukey, 'tenant', tkey, 'state'].join('/'), payload).then(function (res) {
        var sessionData = KvApi.getCachedResource(_getPrefix(ukey));

        var newState = payload.state === 'reject' ? 'denied' : 'accept';

        if (sessionData) {
          sessionData.some(function (tenant) {
            if (tenant.key === tkey) {
              tenant.state = newState;
              return true;
            }
          });
        }
        KvApi.setCachedResource(_getPrefix(ukey), sessionData);
        resolve(res.data);
      }).catch(reject);
    });
  }

  function _getPrefix(ukey) {
    return 'user.' + ukey + '.tenants';
  }

  return {
    get: get,
    getOne: getOne,
    setState: setState
  };
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BankIdFactory; });
BankIdFactory.$inject = ['KvDevice', '$location', 'KvQueryString', '$window'];


// BankId
// -----------
// Handles requests to open BankId app on user's device

function BankIdFactory(KvDevice, $location, KvQueryString, $window) {
  'ngInject';

  var factory = {
    open: openApp
  };

  // Attempt to open BankID app on this device.
  //
  // {Object} opt

  // {String} [opt.autoStartToken] Autostarttoken can be used but is not needed atm
  // {Boolean} [opt.isKivraApp]     It is currently hard for kivra_client to find out for itself if we are on kivra_mobile
  // {String} [opt.orderKey]       BankID order key if this order is to be resumed

  function openApp(opt) {

    switch (KvDevice.parser.getDevice().type) {
      case 'mobile':
      case 'tablet':
        if (opt.isKivraApp) {
          _replaceLocation(opt.autoStartToken, 'kivra://');
        } else {
          switch (KvDevice.parser.getOS().name) {
            case 'Android':
              _openAndroid(opt);
              break;
            case 'iOS':
              _openIOS(opt);
              break;
          }
        }
        // We have tried to open mobile BankID
        return true;
      default:
        // We don't do anything on desktop
        return false;
    }
  }

  function _openAndroid(opt) {

    switch (KvDevice.parser.getBrowser().name) {
      case 'Chrome':
        $window.location.replace('intent://bankid/#Intent;scheme=bankid;package=com.bankid.bus;end');
        break;
      default:
        _replaceLocation(opt.autoStartToken, null);
    }
  }

  function _openIOS(opt) {

    switch (KvDevice.parser.getBrowser().name) {
      case 'Chrome':
        _replaceLocation(opt.autoStartToken, 'googlechrome://');
        break;
      default:
        _replaceLocation(opt.autoStartToken, null);
    }
  }

  function _getBankIdUrl(token, redirect) {
    var url = 'bankid:///?';
    url += 'autostarttoken=' + token;
    url += '&redirect=' + $window.encodeURIComponent(redirect);
    return url;
  }

  function _replaceLocation(token, redirect) {
    $window.location.replace(_getBankIdUrl(token, redirect));
  }

  return factory;
}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvCompanyFactory; });




// KvCompanyFactory
// -----------
// User application interaction wrapper methods to the KvCompanyFactory factory
function KvCompanyFactory() {
  'ngInject';

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
    hasKivraPlus: hasKivraPlus,
    hasScanningService: hasScanningService,
    getKivraPlusState: getKivraPlusState
  });

  /**
   * @desc Get kivra_plus state
   * @param {Object}
   * @return {string|boolean} String if in a particular kivra_plus state, false otherwise.
   **/
  function getKivraPlusState(company) {
    return company.subscriptions !== undefined && company.subscriptions !== null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(company.subscriptions).length > 0 && company.subscriptions.constructor === Object && company.subscriptions.kivra_plus.state ? company.subscriptions.kivra_plus.state : false;
  }

  function hasKivraPlus(company) {
    return company.subscriptions !== undefined && company.subscriptions !== null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(company.subscriptions).length > 0 && company.subscriptions.constructor === Object && company.subscriptions.kivra_plus.state && (company.subscriptions.kivra_plus.state === 'active_ongoing' || company.subscriptions.kivra_plus.state === 'active_ending');
  }

  function hasScanningService(company) {
    return company.services !== undefined && company.services !== null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(company.services).length > 0 && company.services.constructor === Object && company.services.scanning !== undefined && company.services.scanning !== null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(company.services.scanning).length > 0 && company.services.scanning.constructor === Object;
  }
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kvContentFactory; });




// kvContentFactory
// -------------------------
// For one content

function kvContentFactory() {
  'ngInject';

  // Public methods

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
    getGeneratedAt: getGeneratedAt,
    getActorType: getActorType,
    getActorKey: getActorKey,
    hasSupportInfo: hasSupportInfo,
    isRead: isRead,
    isUnread: isUnread
  });

  function getGeneratedAt(content) {
    var hasGeneratedKey = content.generated_at && typeof content.generated_at === 'string';
    return hasGeneratedKey ? content.generated_at : content.created_at;
  }

  function getActorType(content) {
    return content.receiver.match(/^[a-z]*/)[0];
  }

  function getActorKey(content) {
    return content.receiver.match(/[a-z0-9]*$/)[0];
  }

  function isRead(content) {
    return content.labels.viewed;
  }

  function hasSupportInfo(info) {
    if (!info) {
      return false;
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(info).some(function (x) {
      return info[x];
    });
  }

  function isUnread(content) {
    return !isRead(content);
  }
}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvContentsFactory; });




KvContentsFactory.$inject = ['opt'];


// kvContentsFactory
// -------------------------
// For aggregation of multiple content items

function KvContentsFactory(opt) {
  'ngInject';

  // constants

  var CATEGORIES = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze___default()({
    SCANNED: 0,
    USER_AGREEMENTS: 1,
    USER_UPLOADS: 2,
    TRASH: 3,
    TENANT_CONTENT: 4
  });

  // Public methods
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze___default()({
    getGroups: getGroups,
    getCategory: getCategory,
    countUnread: countUnread,
    CATEGORIES: CATEGORIES
  });

  function getGroups(contents) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { alwaysPresent: [] };


    var tenantGroups = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(contents.filter(function (content) {
      return getCategory(content) === CATEGORIES.TENANT_CONTENT;
    }).reduce(function (map, content) {
      map.set(content.sender, [content].concat(map.get(content.sender) || []));
      return map;
    }, new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a()).entries()).map(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          sender = _ref2[0],
          contents = _ref2[1];

      return {
        category: CATEGORIES.TENANT_CONTENT,
        total: contents.length,
        unread: countUnread(contents),
        name: contents[0].sender_name,
        sender: sender
      };
    });

    // We always want all of these miscgroups being present even if for those with no content belonging to them
    var emptyMiscGroupsMap = options.alwaysPresent.reduce(function (map, category) {
      // Initialize category with empty content array in our per-category map
      map.set(category, []);
      return map;
    }, new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a());

    var miscGroups = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(contents.filter(function (content) {
      return getCategory(content) !== CATEGORIES.TENANT_CONTENT;
    }).reduce(function (map, content) {
      map.set(getCategory(content), [content].concat(map.get(getCategory(content)) || []));
      return map;
    }, emptyMiscGroupsMap).entries()).map(function (_ref3) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          category = _ref4[0],
          contents = _ref4[1];

      return {
        category: category,
        total: contents.length,
        unread: countUnread(contents),
        // These keys aren't applicable for miscgroups since they can contain a mix of contents
        name: null,
        sender: null
      };
    });

    return tenantGroups.concat(miscGroups).sort(function (a, b) {
      if (a.category !== b.category) {
        return a.category - b.category;
      }
      if (a.unread !== b.unread) {
        return b.unread - a.unread;
      }
      if (a.total !== b.total) {
        return b.total - a.total;
      }
      if (a.name !== b.name) {
        return a.name - b.name;
      }
      return 0;
    });
  }

  function getCategory(c) {
    if (c.labels && c.labels.trashed) {
      return CATEGORIES.TRASH;
    } else if (c.labels && c.labels.agreement && /user/.test(c.sender)) {
      return CATEGORIES.USER_AGREEMENTS;
    } else if (/user|company/.test(c.sender)) {
      return CATEGORIES.USER_UPLOADS;
    } else if (c.sender.indexOf(opt.scanTenantKey) > -1) {
      return CATEGORIES.SCANNED;
    } else {
      return CATEGORIES.TENANT_CONTENT;
    }
  }

  function countUnread(contents) {
    return contents.reduce(function (sum, content) {
      var unread = !content.labels.viewed && !content.labels.trashed ? 1 : 0;
      return sum + unread;
    }, 0);
  }
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contents_factory__ = __webpack_require__(97);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvContentsProvider; });



// # KvContentsProvider
// manages configuration of the contents util factory
function KvContentsProvider() {
  'ngInject';

  // defaults

  var config = {
    scanTenantKey: '1487261078e76ef6ff5f94458b921dadea18c5312b'
  };

  var provider = {
    set: function set(opt) {
      config = angular.extend(config, opt);
    },
    $get: function $get() {
      return new __WEBPACK_IMPORTED_MODULE_0__contents_factory__["a" /* KvContentsFactory */](config);
    }
  };
  return provider;
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvDeviceFactory; });


// # KvDevice
//
function KvDeviceFactory() {
  'ngInject';

  var factory = {
    getAndroidVersion: getAndroidVersion,
    parser: new UAParser()
  };

  function getAndroidVersion(ua) {
    var re = /Android (\d\.?\d?\.?\d?)/;
    var match = ua.match(re);
    if (match) {
      return match[1];
    }
    // we don't know, i.e firefox mobile < v41 -> assume oldest
    else {
        return '0.0.0';
      }
  }

  return factory;
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kvFormConfigProvider; });
kvFormConfigProvider.$inject = ['KvFormDict'];


// KvFormConfig
// -------------------
//
// Configure e.g angular-schema-form stuff

function kvFormConfigProvider(KvFormDict) {
  'ngInject';

  // defaults

  var config = {
    sfOptions: {
      validationMessage: {
        302: '{{ title }} ' + KvFormDict.INPUT_ERROR_REQUIRED,
        200: '{{ title }} ' + KvFormDict.INPUT_ERROR_TOO_SHORT,
        201: '{{ title }} ' + KvFormDict.INPUT_ERROR_TOO_LONG,
        202: function _(ctx) {
          if (ctx.schema.patternError) {
            return ctx.schema.patternError;
          }
          return ctx.schema.title + ' ' + KvFormDict.INPUT_ERROR_PATTERN;
        },
        email: '{{ title }} ' + KvFormDict.INPUT_ERROR_PATTERN,
        pwdNoMatch: KvFormDict.INPUT_ERROR_PASSWORD_MATCH,
        ssnOfAge: KvFormDict.INPUT_ERROR_UNDER_AGE
      },
      formDefaults: {
        feedback: false,
        ngModelOptions: {
          updateOn: 'blur'
        }
      }
    },
    sfSSN: {
      maxAge: 110,
      minAge: 10,
      minOfAge: 18
    }
  };

  var provider = {
    set: function set(opt) {
      config = angular.extend(config, opt);
    },
    $get: function $get() {
      return config;
    }
  };
  return provider;
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFormDict; });


function getFormDict() {
  'ngInject';

  return {
    '40004': 'Du har redan aktiverat din Kivra. Kontakta support@kivra.com så hjälper vi dig.',
    '40005': 'Fel format ifyllt för mobiltelefonnummer',
    '40006': 'Lösenordet måste bestå av minst 6 tecken varav minst en siffra och en bokstav.',
    '40007': 'Felaktig e-post.',
    '40009': 'Felaktigt personnummer.',
    'INPUT_ERROR_PASSWORD_MATCH': 'Matchar inte angivet lösenord',
    'INPUT_ERROR_PREFIX': 'Ange',
    'INPUT_ERROR_REQUIRED': 'måste anges',
    'INPUT_ERROR_PATTERN': 'fel format',
    'INPUT_ERROR_PATTERN_SSN': 'Måste var ett 10 eller 12 siffrigt svenskt personnummer',
    'INPUT_ERROR_PATTERN_PHONE': 'Måste vara ett giltigt mobiltelefonnummer. Internationella nummer ska anges med inledande plustecken och landskod.',
    'INPUT_ERROR_TOO_SHORT': 'är för kort',
    'INPUT_ERROR_TOO_LONG': 'är för långt',
    'INPUT_ERROR_UNDER_AGE': '<strong>Du är under 18 år.</strong> Har du MobiltBankID kan du registrera dig <a href="/register-bankid">här</a>. Eller <a href="https://www.kivra.com/anvandare-under-18-ar/">klicka här</a> för att läsa mer om hur du kommer igång med hjälp av vår kundtjänst.',
    'INPUT_FIRST_NAME_TITLE': 'Förnamn',
    'INPUT_FIRST_NAME_DESC': 'För att visa i tjänsten',
    'INPUT_USERNAME_TITLE': 'E-post',
    'INPUT_USERNAME_DESC': 'Ange den e-post du har registrerat i Kivra',
    'INPUT_PWD_TITLE': 'Lösenord',
    'INPUT_PWD_DESC': 'Minst 6 tecken varav minst en siffra och en bokstav',
    'INPUT_REGISTRATION_CODE_TITLE': 'Aktiveringskod',
    'INPUT_REGISTRATION_CODE_DESC': 'Ange din 6-siffriga aktiveringskod',
    'INPUT_REGISTRATION_CODE_PLACEHOLDER': 'Aktiveringskod',
    'INPUT_NEW_PWD_TITLE': 'Nytt lösenord',
    'INPUT_NEW_PWD_DESC': 'Minst 6 tecken varav minst en siffra och en bokstav',
    'INPUT_NEW_PWD_REPEAT_TITLE': 'Upprepa nytt lösenord',
    'INPUT_NEW_PWD_REPEAT_PLACEHOLDER': 'Lösenord',
    'INPUT_LAST_NAME_TITLE': 'Efternamn',
    'INPUT_LAST_NAME_DESC': 'För att visa i tjänsten',
    'INPUT_EMAIL_TITLE': 'E-post',
    'INPUT_EMAIL_DESC': 'Notifieringar om nya försändelser skickas hit',
    'INPUT_PRIMARY_EMAIL_DESC': 'Ange den e-post du har registrerat i Kivra',
    'INPUT_SSN_TITLE': 'Personnummer',
    'INPUT_SSN_DESC': 'Posten du tar emot i Kivra är kopplad till ditt personnummer',
    'INPUT_SSN_SHARE_TITLE': 'Personnummer',
    'INPUT_SSN_SHARE_PLACEHOLDER': 'ÅÅÅÅMMDDXXXX',
    'INPUT_SSN_SHARE_DESC': 'Ange personnumret till den person som du vill dela din Kivra med',
    'INPUT_VAT_ORG_TITLE': 'Organisationsnummer',
    'INPUT_VAT_ONBOARD_ORG_DESC': 'Ange organisationsnumret för ert företag',
    'INPUT_PHONE_TITLE': 'Mobiltelefon',
    'INPUT_PHONE_DESC': 'Notifieringar om nya försändelser skickas hit om email inte når fram. Internationella nummer ska anges med inledande plustecken och landskod.',
    'INPUT_CHECKBOX_AGREE': 'Jag förstår',
    'SUBMIT_SAVE_CHANGES': 'Spara',
    'SUBMIT_SUCCESS': 'Ändring sparad!'
  };
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kvFormFactory; });
kvFormFactory.$inject = ['$window', '$timeout'];


// KvForm
// ----------
//

function kvFormFactory($window, $timeout) {
  'ngInject';

  function setReadonly(form, readonly) {
    form.forEach(function (part) {
      part.readonly = readonly;
    });
  }

  function focusFirstInput(form) {
    var id = form[0].key;
    $timeout(function () {
      var elem = $window.document.getElementById(id);
      if (elem) {
        elem.focus();
      }
    }, 0);
  }

  function focusKey(key) {
    $timeout(function () {
      var elem = $window.document.getElementById(key);
      if (elem) {
        elem.focus();
      }
    }, 0);
  }

  var factory = {
    setReadonly: setReadonly,
    focus: focusFirstInput,
    focusKey: focusKey
  };

  return factory;
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parserFactory; });
parserFactory.$inject = ['KvFormConfig'];


// KvFormParserFactory
// ----------
//

function parserFactory(KvFormConfig) {
  'ngInject';

  function ssnParser(value) {
    var max = KvFormConfig.sfSSN.maxAge,
        min = KvFormConfig.sfSSN.minAge,
        seniorPattern = new RegExp('^\\d{6}(\\+)\\d{4}$'),
        nonNumPattern = new RegExp('[^\\d]+', 'g'),
        shortSSNPattern = new RegExp('^(\\d{2})(\\d{2})(\\d{2})(\\d{4})$'),
        longSSNPattern = new RegExp('^(\\d{4})(\\d{2})(\\d{2})(\\d{4})$'),
        now = new Date(),
        n = now.getFullYear(),
        c = parseInt(now.toJSON().substring(0, 2), 10),
        centuries = [c, c - 1];
    if (seniorPattern.test(value)) {
      min = 100;
    }
    if (value) {
      value = value.replace(nonNumPattern, '');
      var ssnMatch = value.match(shortSSNPattern);
      if (ssnMatch) {
        centuries = centuries.filter(function (c) {
          var validMax = c > (n - ssnMatch[1] - max) / 100;
          var validMin = c < (n - ssnMatch[1] - min) / 100;
          return validMax && validMin;
        });
        if (centuries.length === 1) {
          var SSN = centuries[0].toString() + value;
          // convert guessed ssn to date
          var date = new Date(SSN.replace(longSSNPattern, '$1-$2-$3'));
          // only return if valid date
          if (!isNaN(date.getTime())) {
            return SSN;
          }
        }
      }
    }
    return value;
  }

  return {
    ssn: ssnParser
  };
}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userSchemaFactory; });
userSchemaFactory.$inject = ['KvFormDict'];


// KvUserSchema
// ----------
//

function userSchemaFactory(KvFormDict) {
  'ngInject';

  // https://github.com/kivra/kivra_nova/blob/master/src/type_email.erl

  var emailPattern = '^[A-Za-z0-9\\._%+-]+@[A-Za-z0-9\\.-]+\\.[A-Za-z]{2,30}$';
  var ssnPattern = '^[0-9]{10,12}$';
  var orgPattern = '^SE[0-9]{10}01$';
  // https://github.com/kivra/kivra_nova/blob/master/src/type_phone.erl
  var phonePattern = '^\\+[0-9]{3,17}$';
  var codePattern = '^[0-9]{1,6}$';

  var schema = {
    type: 'object',
    properties: {
      receiver_ssn: {
        type: 'string',
        required: true,
        pattern: ssnPattern,
        title: KvFormDict.INPUT_SSN_SHARE_TITLE,
        description: KvFormDict.INPUT_SSN_SHARE_DESC,
        'x-schema-form': {
          type: 'tel',
          placeholder: KvFormDict.INPUT_SSN_PLACEHOLDER
        }
      },
      registration_code: {
        type: 'string',
        required: true,
        pattern: codePattern,
        title: KvFormDict.INPUT_REGISTRATION_CODE_TITLE,
        description: KvFormDict.INPUT_REGISTRATION_CODE_DESC,
        'x-schema-form': {
          type: 'tel',
          placeholder: KvFormDict.INPUT_REGISTRATION_CODE_PLACEHOLDER
        }
      },
      email: {
        type: 'string',
        required: true,
        pattern: emailPattern,
        title: KvFormDict.INPUT_EMAIL_TITLE,
        description: KvFormDict.INPUT_PRIMARY_EMAIL_DESC,
        'x-schema-form': {
          type: 'email',
          placeholder: KvFormDict.INPUT_EMAIL_TITLE
        }
      },
      receiver_email: {
        type: 'string',
        required: true,
        pattern: emailPattern,
        title: KvFormDict.INPUT_EMAIL_TITLE,
        description: KvFormDict.INPUT_EMAIL_DESC,
        'x-schema-form': {
          type: 'email',
          placeholder: KvFormDict.INPUT_EMAIL_TITLE
        }
      },
      receiver_mobile: {
        type: 'string',
        required: true,
        pattern: phonePattern,
        title: KvFormDict.INPUT_PHONE_TITLE,
        description: KvFormDict.INPUT_PHONE_DESC,
        'x-schema-form': {
          type: 'tel',
          placeholder: KvFormDict.INPUT_PHONE_TITLE
        }
      },
      username: {
        type: 'string',
        pattern: emailPattern,
        required: true,
        title: KvFormDict.INPUT_USERNAME_TITLE,
        description: KvFormDict.INPUT_USERNAME_DESC,
        'x-schema-form': {
          type: 'email',
          placeholder: KvFormDict.INPUT_USERNAME_TITLE
        }
      },
      ssn: {
        type: 'string',
        pattern: ssnPattern,
        patternError: KvFormDict.INPUT_ERROR_PATTERN_SSN,
        required: true,
        title: KvFormDict.INPUT_SSN_TITLE,
        description: KvFormDict.INPUT_SSN_DESC,
        'x-schema-form': {
          type: 'tel',
          placeholder: KvFormDict.INPUT_SSN_TITLE
        }
      },
      vat_onboard: {
        type: 'string',
        required: true,
        pattern: orgPattern,
        title: KvFormDict.INPUT_VAT_ORG_TITLE,
        description: KvFormDict.INPUT_VAT_ONBOARD_ORG_DESC,
        'x-schema-form': {
          placeholder: KvFormDict.INPUT_VAT_ORG_TITLE
        }

      },
      password: {
        type: 'string',
        required: true,
        title: KvFormDict.INPUT_PWD_TITLE,
        description: KvFormDict.INPUT_PWD_DESC,
        'x-schema-form': {
          placeholder: KvFormDict.INPUT_PWD_TITLE
        }
      },
      display_name: {
        type: 'object',
        properties: {
          firstname: {
            type: 'string',
            required: true,
            title: KvFormDict.INPUT_FIRST_NAME_TITLE,
            description: KvFormDict.INPUT_FIRST_NAME_DESC
          },
          lastname: {
            type: 'string',
            required: true,
            title: KvFormDict.INPUT_LAST_NAME_TITLE,
            description: KvFormDict.INPUT_LAST_NAME_DESC
          }
        }
      },
      new_password: {
        type: 'string',
        minLength: 6,
        required: true,
        title: KvFormDict.INPUT_NEW_PWD_TITLE,
        description: KvFormDict.INPUT_NEW_PWD_DESC,
        'x-schema-form': {
          placeholder: KvFormDict.INPUT_NEW_PWD_TITLE
        }
      },
      new_password_repeat: {
        type: 'string',
        equalTo: 'new_password',
        required: true,
        title: KvFormDict.INPUT_NEW_PWD_REPEAT_TITLE,
        'x-schema-form': {
          placeholder: KvFormDict.INPUT_NEW_PWD_REPEAT_TITLE
        }
      },
      primary_email: {
        type: 'string',
        pattern: emailPattern,
        required: true,
        title: KvFormDict.INPUT_EMAIL_TITLE,
        description: KvFormDict.INPUT_EMAIL_DESC,
        'x-schema-form': {
          type: 'email',
          placeholder: KvFormDict.INPUT_EMAIL_TITLE
        }
      },
      primary_phone: {
        type: 'string',
        pattern: phonePattern,
        patternError: KvFormDict.INPUT_ERROR_PATTERN_PHONE,
        required: true,
        title: KvFormDict.INPUT_PHONE_TITLE,
        description: KvFormDict.INPUT_PHONE_DESC,
        'x-schema-form': {
          type: 'tel',
          placeholder: KvFormDict.INPUT_PHONE_TITLE
        }
      },
      terms_agree: {
        type: 'boolean',
        required: true,
        title: KvFormDict.INPUT_CHECKBOX_AGREE
      }
    }
  };

  return {
    get: function get() {
      return schema;
    }
  };
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validatorFactory; });
validatorFactory.$inject = ['KvFormConfig'];


// KvFormParserFactory
// ----------
//
function validatorFactory(KvFormConfig) {
  'ngInject';

  function ssnOfAge(ssn) {

    // dont invalidate until we know birthdate
    if (!ssn || ssn.length < 12) {
      return true;
    }

    var today = new Date(),
        birthDate = new Date(ssn.substring(0, 8).replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')),
        age = today.getFullYear() - birthDate.getFullYear(),
        m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
      age--;
    }
    return age >= KvFormConfig.sfSSN.minOfAge;
  }

  return {
    ssnOfAge: ssnOfAge
  };
}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OAuthFactoryProvider; });


// OAuthFactory
// -----------
// The OAuthFactory authenticates the user against an oauth 2.0 endpoint
// And stores a user's session credentials in browser's localstorage
function OAuthFactoryProvider() {
  'ngInject';

  OAuthFactory.$inject = ['$window', '$log', '$q', '$location', '$injector', '$rootScope', '$httpParamSerializer', 'oauthclientConfig', 'localStorageService', 'SessionFactory', 'StateFactory'];
  var LS_PREFIX = 'kv.oauthclient';
  var LS_TOKEN_KEY = [LS_PREFIX, 'access_token'].join('.');
  var LS_UKEY_KEY = [LS_PREFIX, 'user_key'].join('.');

  var UI_STATE_HANDLER = 'ui-router';
  var NG_STATE_HANDLER = 'ng-router';

  var defaults = this.defaults = {
    stateHandler: NG_STATE_HANDLER,
    redirectMethod: function defaultRedirect(url) {
      // need to inject $window since it is not available in config phase
      angular.injector(['ng']).get('$window').location.assign(url);
    }
  };

  var provider = {
    redirectMethod: defaults.redirectMethod,
    stateHandler: defaults.stateHandler,
    setRedirectMethod: function setRedirectMethod(fn) {
      this.redirectMethod = fn;
    },
    setStateHandler: function setStateHandler(handlerName) {
      this.stateHandler = handlerName;
    },
    $get: OAuthFactory
  };

  return provider;

  function OAuthFactory($window, $log, $q, $location, $injector, $rootScope, $httpParamSerializer, oauthclientConfig, localStorageService, SessionFactory, StateFactory) {
    'ngInject';

    // public methods:

    var factory = {
      authenticate: authenticate,
      isAuthenticated: isAuthenticated,
      getEndpointURL: getEndpointURL,
      clear: clear,
      revokeToken: revokeToken,
      getToken: getToken,
      getUkey: getUkey,
      getTokenInfo: getTokenInfo,
      initSession: initSession,
      isExpired: isExpired,
      goToState: goToState,
      _setUkey: _setUkey, // for tests
      _setToken: _setToken // for tests
    };

    function authenticate(opt) {
      provider.redirectMethod(getEndpointURL(opt));
    }

    function getEndpointURL(config) {
      config = config || {};
      var endpointUri = config.endpointUri || oauthclientConfig.endpointUri;
      var params = angular.extend({}, {
        client_id: oauthclientConfig.clientId,
        redirect_uri: oauthclientConfig.clientHost + oauthclientConfig.redirectRoute,
        response_type: oauthclientConfig.responseType,
        state: ''
      }, oauthclientConfig.customEndpointParams, config.params);
      return endpointUri + '?' + $httpParamSerializer(params);
    }

    function revokeToken(token) {
      var $http = $injector.get('$http');
      return $http['delete'](oauthclientConfig.tokenInfoUrl + '/' + token);
    }

    function getToken() {
      return localStorageService.get(LS_TOKEN_KEY);
    }

    function getUkey() {
      return localStorageService.get(LS_UKEY_KEY);
    }

    function isExpired(session) {
      var expiresAt;
      try {
        expiresAt = new Date(session.expiry_time * 1000);
      } catch (e) {
        throw new Error('[KvOauthFactory] Failed parsing session.expiry_time from tokenInfo: ' + e.message);
      }
      var now = new Date();
      if (expiresAt < now) {
        return true;
      }
      return false;
    }

    function _setToken(token) {
      return localStorageService.set(LS_TOKEN_KEY, token);
    }

    function _setUkey(ukey) {
      return localStorageService.set(LS_UKEY_KEY, ukey);
    }

    function getTokenInfo(token) {
      var $http = $injector.get('$http');
      return $http.get(oauthclientConfig.tokenInfoUrl + '/' + token);
    }

    function goToState(stateString) {
      switch (provider.stateHandler) {
        case NG_STATE_HANDLER:
          $location.path(stateString);
          // Don't put the current transient state in history
          return $location.replace();
        case UI_STATE_HANDLER:
          return StateFactory.goTo(stateString);
      }
    }

    /**
     * Checks if user is authenticated by comparing current time
     * and expiry_time.
     */
    function isAuthenticated() {
      var currentTime = Math.floor(Date.now() / 1000);
      var expiryTime = SessionFactory.getKey('expiry_time');

      if (typeof expiryTime === 'number' && Math.round(expiryTime) === expiryTime && currentTime < expiryTime) {
        return true;
      }

      return false;
    }

    function initSession(params) {
      var dfd = $q.defer();
      getTokenInfo(params.access_token).then(function (res) {
        var tokenInfo = res.data;
        var owner = tokenInfo.resource_owner;
        var userKey = owner.substr(owner.length - 42); // only get ukey from resource_owner string
        // we cant be sure storage works
        if (_setUkey(userKey) && _setToken(params.access_token)) {
          SessionFactory.set(tokenInfo);
          $rootScope.$broadcast(oauthclientConfig.EVENT_SESSION_INIT, {
            resourceOwner: userKey
          });
          dfd.resolve(params.state);
        } else {
          $rootScope.$broadcast(oauthclientConfig.EVENT_ERR_STORAGE);
          dfd.reject(oauthclientConfig.EVENT_ERR_STORAGE);
        }
      }, function (err) {
        // something went wrong, try to authenticate again!
        $log.error('Token validation error', err);
        $rootScope.$broadcast(oauthclientConfig.EVENT_ERR_TOKENVALIDATE, err);
        dfd.reject(err);
      });

      return dfd.promise;
    }

    function clear() {
      localStorageService.clearAll();
    }

    $rootScope.$on('LocalStorageModule.notification.error', function (event, val) {

      // other errors are OK for now
      if (val === 'COOKIES_NOT_SUPPORTED') {
        $rootScope.$broadcast(oauthclientConfig.EVENT_ERR_STORAGE);
      }
    });

    return factory;
  }
}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OAuthInterceptor; });
OAuthInterceptor.$inject = ['$log', '$q', '$location', '$window', 'oauthclientConfig', '$rootScope', 'OAuthFactory'];


// OAuthInterceptor
// ---------------
// $http interceptor which adds Authorization token in header to API requests and redirects
// the browser to OAuth authorization endpoint if the user isn't authorized to access
// an API resource

function OAuthInterceptor($log, $q, $location, $window, oauthclientConfig, $rootScope, OAuthFactory) {
  'ngInject';

  function _isApiRequest(config) {
    return new RegExp(oauthclientConfig.apiUrl).test(config.url);
  }

  function catchUnauthorized(err) {
    if (err.status === 401 && _isApiRequest(err.config)) {
      $log.error('401 on API request', err.config);
      $rootScope.$broadcast(oauthclientConfig.EVENT_ERR_UNAUTHORIZED, err.config);
    }
    return $q.reject(err);
  }

  function handleAPIRequest(config) {
    if (_isApiRequest(config)) {
      config.headers['Authorization'] = 'token ' + OAuthFactory.getToken();
    }
    return config;
  }

  return {
    responseError: catchUnauthorized,
    request: handleAPIRequest
  };
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OauthclientConfigProvider; });


// oauthclientConfigProvider
// -------------------------
// This provider enabales a module to toggle all setting specific routes
// on/off during its config phase by calling userSettingsProvider.enable(bool)

function OauthclientConfigProvider() {
  'ngInject';

  // defaults

  var config = {
    clientHost: 'http://localhost:1337',
    redirectRoute: '/#/auth/kivra/return',
    endpointUri: 'https://sandbox-accounts.kivra.com/auth',
    clientId: '14085255171411300228f14dceae786da5a00285fe',
    apiUrl: 'https://sandbox.kivra.com',
    tokenInfoUrl: 'https://sandbox.kivra.com/v1/auth/tokeninfo',
    customEndpointParams: {},
    scope: null,

    // EVENT name constants for depending app to listen on and control behaviour

    // `EVENT_SESSION_INIT` broadcasts `{ resourceOwner: <String> }`
    // when a session is succesfully initialilized
    EVENT_SESSION_INIT: 'kv.oauthclient:session_init',
    // `EVENT_ERR_UNAUTHORIZED` broadcasts err Object
    // when a 401 responce from the API is discovered
    EVENT_ERR_UNAUTHORIZED: 'kv.oauthclient:unauthorized',
    // `EVENT_ERR_TOKENVALIDATE` broadcasts err Object
    // when a request to validate a token fails
    EVENT_ERR_TOKENVALIDATE: 'kv.oauthclient:token_validate_error',
    // `EVENT_ERR_STORAGE` broadcasts err Object
    // when module is unable to store credentials
    EVENT_ERR_STORAGE: 'kv.oauthclient:storage_error'
  };

  var provider = {
    set: function set(opt) {
      config = angular.extend(config, opt);
    },
    addAuthInterceptor: function addAuthInterceptor($httpProvider) {
      $httpProvider.interceptors.push('OAuthInterceptor');
    },
    $get: function $get() {
      return config;
    }
  };

  return provider;
}

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OAuthReturnCtrl; });

OAuthReturnCtrl.$inject = ['$log', '$location', 'OAuthFactory', 'KvQueryString'];


// OAuthReturnCtrl
// --------------
// Controller to catch stuff sent in the fragment from an OAuth2.0 endpoint
function OAuthReturnCtrl($log, $location, OAuthFactory, KvQueryString) {
  'ngInject';

  var fragParams = KvQueryString.parse($location.hash());
  var getParams = $location.search();

  var params = angular.extend({}, getParams, fragParams);

  $log.debug('[kv.oauthclient]\t Return from OAuth controller with params: ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));

  if (params.access_token) {
    OAuthFactory.initSession(params).then(OAuthFactory.goToState, angular.noop);
  } else if (params.state) {
    OAuthFactory.goToState(params.state);
  }
}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OAuthRoutesFactory; });
OAuthRoutesFactory.$inject = ['oauthclientConfig'];


function OAuthRoutesFactory(oauthclientConfig) {
  'ngInject';

  var factory = {
    getRoutes: getReturnRoute
  };

  function getReturnRoute() {
    'ngInject';

    return {
      url: oauthclientConfig.redirectRoute.substr(2), // remove hash
      config: {
        template: '',
        controller: 'OAuthReturnCtrl'
      }
    };
  }

  return factory;
}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvPaymentFactory; });



// # KvPayment
function KvPaymentFactory() {
  'ngInject';

  var factory = {
    group: group,
    normalizeStatus: normalizeStatus
  };

  var paymentStatusMap = {
    PAYMENTS_PENDING: new RegExp('^(unpaid|pending|ag_approved)$', 'i'),
    PAYMENTS_PAID: new RegExp('^paid$', 'i'),
    PAYMENTS_CANCELED: new RegExp('^canceled$|^error_', 'i')
  };

  function group(payments) {

    var paymentGroups = {
      PAYMENTS_ALL: payments
    };

    function filterKeyByRegex(key, regex) {
      return function (item) {
        return regex.test(item[key]);
      };
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(paymentStatusMap).forEach(function (pgroup) {
      paymentGroups[pgroup] = payments.filter(filterKeyByRegex('status', paymentStatusMap[pgroup]));
    });

    return paymentGroups;
  }

  function normalizeStatus(paymentStatus) {
    for (var status in paymentStatusMap) {
      if (paymentStatusMap[status].test(paymentStatus)) {
        return status;
      }
    }
    return 'PAYMENTS_OTHER';
  }

  return factory;
}

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvQueryString; });



// KvQueryString
// -------------
// This service stringifies and parses query-strings.

function KvQueryString() {
  'ngInject';

  return {
    // `stringify({Object,<String>}})`
    //
    // Return query-string.
    stringify: function QueryStringStringify(params) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params || {}).map(function (value) {
        return value + '=' + encodeURIComponent(params[value]);
      }).join('&');
    },

    // `parse({String})`
    //
    // Return query-string parameters as an Object.
    parse: function QueryStringParse(string) {
      var params = {};
      string.split('&').map(function (value) {
        value = value.split('=');
        params[value[0]] = decodeURIComponent(value[1]);
      });
      return params;
    }
  };
}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvRouterCtrl; });
KvRouterCtrl.$inject = ['$scope', 'KvRouter'];


function KvRouterCtrl($scope, KvRouter) {
  'ngInject';

  angular.extend($scope, {
    routes: KvRouter.getRoutes()
  });
}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvRouterProvider; });
KvRouterProvider.$inject = ['$routeProvider'];


function KvRouterProvider($routeProvider) {
  'ngInject';

  var config = {
    $routeProvider: $routeProvider,
    defaultPath: '/'
  };

  function setDefault(path) {
    config.defaultPath = path;
  }

  var provider = {
    config: config,
    setDefaultPath: setDefault,
    $get: KvRouter
  };

  function KvRouter() {

    var $routeProvider = provider.config.$routeProvider;

    var factory = {
      addRoutes: addRoutes,
      getRoutes: getRoutes,
      routes: []
    };

    // enables different modules to hook up into the same $routeProvider
    function addRoutes(routes) {
      routes.forEach(function (route) {
        $routeProvider.when(route.url, route.config);
      });
      $routeProvider.otherwise({ redirectTo: provider.config.defaultPath });
      factory.routes = factory.routes.concat(routes);
    }

    function getRoutes() {
      return factory.routes;
    }

    return factory;
  }
  return provider;
}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SessionFactory; });

SessionFactory.$inject = ['localStorageService'];


// SessionFactory
// --------------
// This service stores arbitrary session data

function SessionFactory(localStorageService) {
  'ngInject';

  var LS_PREFIX = 'kv.session';
  var LS_SESSION = [LS_PREFIX, 'session'].join('.');

  return {
    // `set({Object})`
    //
    // Set the full session object.
    set: function set(session) {
      var sessionString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(session);
      return localStorageService.set(LS_SESSION, sessionString);
    },

    // `get()`
    //
    // Return the full session object.
    get: function get() {
      var sessionString = localStorageService.get(LS_SESSION);
      return JSON.parse(sessionString);
    },

    // `setKey({String}, {Object})`
    //
    // Set an arbritary top-level key in the session object.
    setKey: function setKey(key, data) {
      var session = this.get() || {};
      session[key] = data;
      var sessionString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(session);
      return localStorageService.set(LS_SESSION, sessionString);
    },

    // `getKey({String})`
    //
    // Get an arbritary top-level key in the session object.
    getKey: function getKey(key) {
      var sessionString = localStorageService.get(LS_SESSION);
      if (sessionString !== null) {
        return JSON.parse(sessionString)[key];
      }

      return undefined;
    },

    // `clear()`
    //
    // Clear the full session object.
    clear: function clear() {
      return localStorageService.set(LS_SESSION, null);
    }
  };
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StateFactory; });

StateFactory.$inject = ['$injector'];


// StateFactory
// -----------

function StateFactory($injector) {
  'ngInject';

  function parse(stateString) {

    var state = {
      name: stateString,
      params: {}
    };

    var index = stateString.indexOf('(');

    if (index !== -1) {
      state.name = stateString.substring(index, -1);
      try {
        state.params = stateString.substring(index);
        state.params = state.params.substring(1, state.params.length - 1);
        state.params = JSON.parse(state.params);
      } catch (err) {
        throw new Error('Failed to parse state params: ' + err.message + ': ' + stateString);
      }
    }

    return state;
  }

  // `stringify({String}, {Object,<String>})`
  // ```javascript
  // StateFactory.stringify('herp.derp', { id: 'derp' })
  // 'herp.derp({"id": "derp"})'
  // ```
  function stringify(name, params) {
    return name + '(' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params || {}) + ')';
  }

  function getCurrentString() {
    // only depend on $state module if app uses this method
    var state = $injector.get('$state').current;
    return stringify(state.name, state.params);
  }

  function goTo(stateString) {
    // only depend on $state module if app uses this method
    var $state = $injector.get('$state');
    var state = parse(stateString);
    return $state.go(state.name, state.params);
  }

  return {
    parse: parse,
    stringify: stringify,
    getCurrent: getCurrentString,
    goTo: goTo
  };
}

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KvTenantFactory; });



// KvTenantFactory
// -----------
// User application interaction wrapper methods to the KvTenantFactory factory
function KvTenantFactory() {
  'ngInject';

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
    isMM: isMM,
    isEditable: isEditable,
    getEditStatus: getEditStatus,
    getActiveTenants: getActiveTenants,
    toggleTenantState: toggleTenantState
  });

  function isMM(tenant) {
    return tenant.groups.lastIndexOf('minameddelanden.se') > -1;
  }

  function isEditable(tenant) {
    return tenant.editable;
  }

  function getEditStatus(tenant) {
    var errors = {
      TENANT_NOT_EDITABLE: 'tenant is not editable',
      TENANT_MANDATORY: 'tenant is mandatory',
      INVALID_STATE: 'invalid state',
      USER_REJECTED: 'user rejected',
      MM_ONBOARD_REQUIRED: 'user needs to onboard MM to edit this tenant',
      BANKID_SIGN_REQUIRED: 'user needs to sign with mobile BankID to edit this tenant'
    };

    var statuses = {
      OK: 'user can edit tenant',
      MM_SIGN_REQUIRED: 'user can edit tenant through bankid sign'
    };

    if (tenant.status === 'mandatory') {
      return errors.TENANT_MANDATORY;
    } else if (isEditable(tenant)) {
      return errors.TENANT_NOT_EDITABLE;
    } else if (isMM(tenant)) {
      return statuses.MM_SIGN_REQUIRED;
    }

    return statuses.OK;
  }

  function getActiveTenants(tenants, content) {
    var senders = content.map(function (content) {
      return content.sender;
    });
    var tenantsNew = tenants.slice();

    return tenantsNew.map(function (tenant) {
      if (senders.indexOf('tenant_' + tenant.key) !== -1) {
        tenant.userRelation = true;
      }
      return tenant;
    });
  }

  function toggleTenantState(state) {
    return state === 'accept' ? 'reject' : 'accept';
  }
}

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contentIconDir; });
contentIconDir.$inject = ['uiConfig'];


// ContentIconDir
// --------------
// Sets an image elements src attr to some icon on a CDN host based on labels and sender
function contentIconDir(uiConfig) {
  'ngInject';

  var extension = '.svg';

  return {
    restrict: 'A',
    transclude: true,
    scope: {
      sender: '=',
      labels: '='
    },
    link: function link(scope, elem) {

      var setTenantIcon = function setTenantIcon(key) {
        elem.css('visibility', 'hidden');
        elem.prop('src', uiConfig.resourceUrl + '/img/tenant/' + key + '/icon' + extension);
      };

      function getIconKey() {
        var key = 'default';
        var sender = scope.sender;
        var labels = scope.labels;
        if (sender) {
          if (sender.indexOf('tenant_') === 0) {
            key = sender.replace('tenant_', '');
          } else if (sender.indexOf('user_') === 0) {
            if (labels && labels.agreement) {
              key = 'contract';
            } else {
              key = 'user';
            }
          } else {
            key = sender;
          }
        }
        return key;
      }

      scope.$watchGroup(['sender', 'labels'], update);

      function update() {
        setTenantIcon(getIconKey());
      }

      elem[0].addEventListener('load', function (e) {
        elem.css('visibility', 'visible');
        e.preventDefault();
      });

      elem[0].addEventListener('error', function (e) {
        setTenantIcon('default');
        e.preventDefault();
      });
    }
  };
}

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return uiConfigProv; });


function uiConfigProv() {
  'ngInject';

  var config = {
    resourceUrl: 'https://static.kivra.com'
  };

  var provider = {
    setResourceUrl: function setResourceUrl(url) {
      config.resourceUrl = url;
    },
    $get: function $get() {
      return config;
    }
  };

  return provider;
}

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneUtilFactory; });



// VatUtilFactory
// -------------
function PhoneUtilFactory() {
  'ngInject';

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
    parse: parse
  });

  // `parse({String:phoneNr})`
  //
  // Parses a user inputted phone number to a kivra_core acceptable format (always prefixed with +CC)
  function parse(input) {

    var trim = function trim(str) {
      return str.trim();
    };
    var phonenumeric = function phonenumeric(str) {
      return str.replace(/[- =]/g, '');
    };
    var prefix = function prefix(str) {
      return str.substr(0, 1) === '+' ? str : '+46' + str.substr(1);
    };

    return prefix(phonenumeric(trim(input)));
  }
}

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RedirectFactory; });
RedirectFactory.$inject = ['$window'];


// RedirectFactory
// -------------
// safe redirections from incoming  non-trusted URL input
// asserting that URL is a "safe" place to redirect the user

function RedirectFactory($window) {
  'ngInject';

  return {
    redirect: redirect,
    isOk: isOk
  };

  function isOk(url) {
    return url.match(/^https:\/\/([a-z-]+\.)?kivra.com(\/.*)?$/);
  }

  function redirect(url) {

    if (isOk(url)) {
      return $window.location.assign(url);
    } else {
      throw new Error('url ' + url + ' considered unsafe for redirect');
    }
  }
}

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SemVerFactory; });


// SemVerFactory
// -------------
function SemVerFactory() {
  'ngInject';

  // parses and compares semantic version numbers
  // on the format major.minor.patch

  return {
    parse: parse,
    compare: compare,
    isOlder: function isOlder(a, b) {
      return compare(a, b) === 1;
    }
  };

  // `parse({String})`
  //
  // Parses a semver string, throws error if invalid
  function parse(semver) {

    var parts = semver.split('.');

    function s2n(s) {
      var n = parseInt(Number(s), 0);
      if (isNaN(n)) {
        throw new Error('Invalid semver version: ' + semver);
      }
      return n;
    }

    return {
      major: s2n(parts[0]),
      minor: s2n(parts[1] || 0),
      patch: s2n(parts[2] || 0)
    };
  }

  // `compare({String}, {String})`
  //
  // Compares two semver strings
  // can be passed as argument to Array.sort
  function compare(a, b) {

    a = parse(a);
    b = parse(b);

    if (a.major > b.major) {
      return -1;
    }
    if (a.major < b.major) {
      return 1;
    }

    if (a.minor > b.minor) {
      return -1;
    }
    if (a.minor < b.minor) {
      return 1;
    }

    if (a.patch > b.patch) {
      return -1;
    }
    if (a.patch < b.patch) {
      return 1;
    }

    return 0;
  }
}

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VatUtilFactory; });



// VatUtilFactory
// -------------
function VatUtilFactory() {
  'ngInject';

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
    parse: parse,
    format: format
  });

  // `parse({String:orgNr})`
  //
  // Parses a swedish org number to the International VAT format
  function parse(org) {

    var vat = org.trim().replace('-', '');
    return 'SE' + vat + '01';
  }

  // `format({String:vat})`
  //
  // Formats a number in the the International VAT format to a human readable form (orgNr)
  function format(vat) {

    // https://en.wikipedia.org/wiki/VAT_identification_number
    var match = vat.match(/SE(\d{10})\d{2}$/);
    if (match) {
      return match[1];
    }
    return undefined;
  }
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(131), __esModule: true };

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(132), __esModule: true };

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(133), __esModule: true };

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(135), __esModule: true };

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(136), __esModule: true };

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(126);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(125);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(198);
module.exports = __webpack_require__(38).Array.find;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
__webpack_require__(169);
module.exports = __webpack_require__(0).Array.from;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37);
__webpack_require__(19);
module.exports = __webpack_require__(167);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37);
__webpack_require__(19);
module.exports = __webpack_require__(168);

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__(0)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(175);
__webpack_require__(19);
__webpack_require__(37);
__webpack_require__(171);
__webpack_require__(176);
module.exports = __webpack_require__(0).Map;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(172);
module.exports = __webpack_require__(0).Object.assign;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(173);
module.exports = __webpack_require__(0).Object.freeze;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(174);
module.exports = __webpack_require__(0).Object.keys;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(25);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(34)
  , toLength  = __webpack_require__(18)
  , toIndex   = __webpack_require__(165);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(12)
  , IObject  = __webpack_require__(26)
  , toObject = __webpack_require__(14)
  , toLength = __webpack_require__(18)
  , asc      = __webpack_require__(145);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7)
  , isArray  = __webpack_require__(152)
  , SPECIES  = __webpack_require__(2)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(144);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(4).f
  , create      = __webpack_require__(50)
  , redefineAll = __webpack_require__(52)
  , ctx         = __webpack_require__(12)
  , anInstance  = __webpack_require__(44)
  , defined     = __webpack_require__(17)
  , forOf       = __webpack_require__(25)
  , $iterDefine = __webpack_require__(27)
  , step        = __webpack_require__(49)
  , setSpecies  = __webpack_require__(163)
  , DESCRIPTORS = __webpack_require__(5)
  , fastKey     = __webpack_require__(28).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(23)
  , from    = __webpack_require__(141);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(3)
  , $export        = __webpack_require__(9)
  , meta           = __webpack_require__(28)
  , fails          = __webpack_require__(10)
  , hide           = __webpack_require__(6)
  , redefineAll    = __webpack_require__(52)
  , forOf          = __webpack_require__(25)
  , anInstance     = __webpack_require__(44)
  , isObject       = __webpack_require__(7)
  , setToStringTag = __webpack_require__(31)
  , dP             = __webpack_require__(4).f
  , each           = __webpack_require__(143)(0)
  , DESCRIPTORS    = __webpack_require__(5);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function(target, iterable){
      anInstance(target, C, NAME, '_c');
      target._c = new Base;
      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','),function(KEY){
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
        anInstance(this, C, KEY);
        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    if('size' in proto)dP(C.prototype, 'size', {
      get: function(){
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(4)
  , createDesc      = __webpack_require__(30);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3).document && document.documentElement;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(5) && !__webpack_require__(10)(function(){
  return Object.defineProperty(__webpack_require__(45)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(24);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(50)
  , descriptor     = __webpack_require__(30)
  , setToStringTag = __webpack_require__(31)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(6)(IteratorPrototype, __webpack_require__(2)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(2)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(29)
  , gOPS     = __webpack_require__(158)
  , pIE      = __webpack_require__(161)
  , toObject = __webpack_require__(14)
  , IObject  = __webpack_require__(26)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(10)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(4)
  , anObject = __webpack_require__(8)
  , getKeys  = __webpack_require__(29);

module.exports = __webpack_require__(5) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 158 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(13)
  , toObject    = __webpack_require__(14)
  , IE_PROTO    = __webpack_require__(32)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(13)
  , toIObject    = __webpack_require__(34)
  , arrayIndexOf = __webpack_require__(142)(false)
  , IE_PROTO     = __webpack_require__(32)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 161 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(6);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(3)
  , core        = __webpack_require__(0)
  , dP          = __webpack_require__(4)
  , DESCRIPTORS = __webpack_require__(5)
  , SPECIES     = __webpack_require__(2)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(33)
  , defined   = __webpack_require__(17);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(33)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(7);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8)
  , get      = __webpack_require__(36);
module.exports = __webpack_require__(0).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(23)
  , ITERATOR  = __webpack_require__(2)('iterator')
  , Iterators = __webpack_require__(11);
module.exports = __webpack_require__(0).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(12)
  , $export        = __webpack_require__(9)
  , toObject       = __webpack_require__(14)
  , call           = __webpack_require__(48)
  , isArrayIter    = __webpack_require__(47)
  , toLength       = __webpack_require__(18)
  , createProperty = __webpack_require__(149)
  , getIterFn      = __webpack_require__(36);

$export($export.S + $export.F * !__webpack_require__(154)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(140)
  , step             = __webpack_require__(49)
  , Iterators        = __webpack_require__(11)
  , toIObject        = __webpack_require__(34);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(27)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(146);

// 23.1 Map Objects
module.exports = __webpack_require__(148)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(9);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(156)});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(7)
  , meta     = __webpack_require__(28).onFreeze;

__webpack_require__(51)('freeze', function($freeze){
  return function freeze(it){
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(14)
  , $keys    = __webpack_require__(29);

__webpack_require__(51)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 175 */
/***/ (function(module, exports) {



/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(9);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(147)('Map')});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(58)('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(40)(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(55)
  , IObject  = __webpack_require__(188)
  , toObject = __webpack_require__(196)
  , toLength = __webpack_require__(195)
  , asc      = __webpack_require__(182);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20)
  , isArray  = __webpack_require__(189)
  , SPECIES  = __webpack_require__(58)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(181);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20)
  , document = __webpack_require__(15).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(15)
  , core      = __webpack_require__(38)
  , hide      = __webpack_require__(40)
  , redefine  = __webpack_require__(192)
  , ctx       = __webpack_require__(55)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 186 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(39) && !__webpack_require__(56)(function(){
  return Object.defineProperty(__webpack_require__(184)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(54);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(54);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(179)
  , IE8_DOM_DEFINE = __webpack_require__(187)
  , toPrimitive    = __webpack_require__(197)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(39) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(15)
  , hide      = __webpack_require__(40)
  , has       = __webpack_require__(186)
  , SRC       = __webpack_require__(57)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(38).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(194)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(183);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(185)
  , $find   = __webpack_require__(180)(5)
  , KEY     = 'find'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(178)(KEY);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_alert_alert_module_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_api_module_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_bankid_bankid_module_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_company_company_module_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_content_content_module_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_device_device_module_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_form_form_module_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_oauthclient_oauthclient_module_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_payment_payment_module_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_querystring_querystring_module_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_router_router_module_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_session_session_module_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_state_state_module_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_tenant_tenant_module_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_ui_ui_module_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_util_util_module_js__ = __webpack_require__(72);

















/***/ })
/******/ ]);